var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _g, _g2, _path194, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 198,
    viewBox: "0 0 386 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_9888)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_9888)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "#0E917A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.613 140.627C118.736 144.733 119.31 197.882 113 228.046V256.682L477.807 271L484.116 64.2459C496.162 1.24598 381.824 -33.0113 338.423 7.54598C293.683 49.355 301.139 135.472 199.613 140.627Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.81 165.537C220.425 160.637 224.135 152.571 225.579 142.289C227.197 130.784 224.099 117.129 224.099 117.129C224.099 117.129 218.31 131.19 216.519 142.289C214.913 152.245 216.459 161.668 215.887 165.677L219.81 165.537Z",
    fill: "url(#paint0_linear_10322_9888)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.142 166.023C209.597 161.617 206.412 154.411 205.177 145.322C203.812 135.274 206.42 123.511 206.42 123.511C206.42 123.511 211.318 135.625 212.876 145.322C214.293 154.124 213.01 162.54 213.52 166.151L210.142 166.023Z",
    fill: "url(#paint1_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.81 165.537C220.425 160.637 224.135 152.571 225.579 142.289C227.197 130.784 224.099 117.129 224.099 117.129C224.099 117.129 218.31 131.19 216.519 142.289C214.913 152.245 216.459 161.668 215.887 165.677L219.81 165.537Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.142 166.023C209.597 161.617 206.412 154.411 205.177 145.322C203.812 135.274 206.42 123.511 206.42 123.511C206.42 123.511 211.318 135.625 212.876 145.322C214.293 154.124 213.01 162.54 213.52 166.151L210.142 166.023Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.704 165.677C216.704 160.131 219.415 150.908 219.589 138.985C219.786 125.417 214.814 109 214.814 109C214.814 109 210.717 125.899 210.37 138.985C210.062 150.533 212.856 161.298 212.801 165.832L216.704 165.673V165.677Z",
    fill: "url(#paint2_linear_10322_9888)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.762 165.689C223.839 160.502 228.286 151.927 230.733 140.927C233.491 128.527 231.775 113.682 231.775 113.682C231.775 113.682 224.604 128.965 221.743 140.927C219.198 151.58 219.83 161.597 218.886 165.836L222.762 165.689Z",
    fill: "url(#paint3_linear_10322_9888)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.669 165.705C205.663 161.151 201.551 153.694 199.341 144.259C196.89 133.789 198.548 121.488 198.548 121.488C198.548 121.488 205.004 134.156 207.616 144.259C209.98 153.396 209.408 162.11 210.296 165.836L206.669 165.705Z",
    fill: "url(#paint4_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.548 121.488C198.548 121.488 199.436 135.211 202.143 144.773C204.167 151.927 208.445 161.593 209.637 165.769L206.669 165.705C205.663 161.151 201.551 153.694 199.341 144.259C196.89 133.789 198.548 121.488 198.548 121.488Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.887 165.677C215.615 161.895 213.211 150.131 213.389 138.26C213.614 123.3 214.814 109.004 214.814 109.004C214.814 109.004 210.717 125.903 210.37 138.989C210.062 150.537 212.856 161.302 212.801 165.836L215.887 165.677Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.704 165.689C222.75 160.502 222.347 151.788 224.439 140.768C226.799 128.348 231.775 113.678 231.775 113.678C231.775 113.678 224.604 128.961 221.743 140.923C219.198 151.577 219.83 161.593 218.886 165.832L221.7 165.685L221.704 165.689Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.519 130.959C200.576 131.15 201.488 136.918 202.948 142.289C204.27 147.141 206.037 151.668 207.3 151.445C209.956 150.971 203.082 130.644 201.519 130.959Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.729 124.024C229.81 123.746 227.805 131.043 226.59 136.473C225.493 141.381 224.881 148.165 226.1 148.563C227.268 148.949 229.324 143.384 230.338 137.81C231.546 131.17 231.558 124.275 230.729 124.024Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.706 119.219C214.329 119.247 214.06 145.688 216.981 145.772C219.901 145.855 217.431 119.187 215.706 119.219Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.551 191.287H220.603C223.867 184.877 226.522 176.41 228.543 164.781H200.608C202.778 177.186 205.414 185.486 208.548 191.287H208.551Z",
    fill: "url(#paint5_linear_10322_9888)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.955 166.7C200.837 166.071 200.722 165.434 200.608 164.781H228.543C228.428 165.43 228.314 166.071 228.2 166.7H200.955Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.919 164.781C210.919 164.781 211.87 180.896 214.656 191.287H208.548C205.414 185.486 202.778 177.19 200.608 164.781H210.919Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M364.344 81.5794L298.238 148.268L300.348 150.396L366.454 83.7078L364.344 81.5794Z",
    fill: "url(#paint6_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M298.818 147.681L361.277 84.6714L364.346 81.5752L365.148 82.3839L366.457 83.7047L363.189 87.0019C362.809 86.5042 362.42 86.0209 362.022 85.5375L299.686 148.423C300.165 148.825 300.644 149.217 301.137 149.6L300.355 150.39L298.249 148.26L298.827 147.676L298.818 147.681Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M326.572 181.998H331.961V159.416H326.572V181.998Z",
    fill: "url(#paint7_linear_10322_9888)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 153.764C351.648 153.764 369.792 135.46 369.792 112.882C369.792 90.3035 351.648 72 329.267 72C306.886 72 288.742 90.3035 288.742 112.882C288.742 135.46 306.886 153.764 329.267 153.764Z",
    fill: "url(#paint8_linear_10322_9888)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M333.513 125.066C335.951 123.497 339.362 123.612 341.914 121.98C343.223 121.142 344.456 119.994 345.647 119.046C346.501 118.367 347.364 117.041 348.365 116.347C349.727 115.405 350.471 116.204 351.966 115.912C353.374 115.639 354.024 114.711 355.699 114.869C355.329 115.242 355.637 114.739 355.528 115.462C356.809 115.787 358.488 117.912 358.616 119.041C358.725 120.008 357.848 121.042 357.98 122.142C358.113 123.224 358.782 123.908 358.815 125.057C358.882 127.435 357.596 128.78 356.159 130.34C355.02 131.579 354.366 133.273 352.995 134.336C352.127 135.01 351.017 135.231 350.101 135.834C346.695 138.078 346.629 143.471 344.252 146.4C343.55 147.266 337.569 152.559 336.051 151.003C335.268 150.199 336.795 149.879 337.004 149.171C337.274 148.252 336.942 147.893 336.881 147.075C336.729 145.156 335.581 143.658 335.377 141.849C335.258 140.763 336.264 139.715 335.439 138.743C334.964 138.188 334.125 138.59 333.522 138.308C331.269 137.25 331.625 135.661 332.014 133.474C332.555 130.436 330.344 127.11 333.518 125.066H333.513Z",
    fill: "url(#paint9_radial_10322_9888)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M368.094 113.777C367.093 114.183 366.187 113.566 365.229 114.049C364.512 114.408 364.048 115.322 363.421 115.337C363.085 115.581 362.653 115.667 362.207 115.629C361.405 113.906 363.459 112.992 364.607 112.14C365.428 111.527 365.921 111.795 366.415 110.633C366.832 109.642 366.732 108.34 366.69 107.264C366.581 104.651 364.19 103.426 361.714 103.88C360.68 104.072 360.229 104.804 359.29 103.823C358.436 102.928 358.479 101.464 357.511 100.468C355.556 98.4632 354.494 96.1902 351.947 94.8981C350.699 94.2664 349.394 93.6012 348.346 92.7686C346.624 91.4047 347.938 91.041 347.26 89.4571C346.757 88.2751 345.552 88.5861 344.499 88.3229C343.498 88.0741 341.757 87.519 341.188 86.5858C340.41 85.3033 341.159 84.6094 341.629 83.5088C341.857 82.9728 341.454 82.4655 342.037 82.0827C343.009 81.4462 343.133 82.6857 343.835 82.6904C344.508 82.6952 344.755 82.0731 345.31 82.0779C346.373 82.0875 346.449 82.8149 347.094 83.4848C348.46 84.9013 350.405 85.6048 352.397 85.3799C354.152 85.1837 355.258 84.6333 353.479 83.2886C352.615 82.6378 352.264 82.9871 352.065 81.7621C352.018 81.4797 352.454 80.9294 352.255 80.3839C352.644 80.1972 353.085 80.1255 353.559 80.1446C363.251 87.4759 369.579 99.0806 369.792 112.193C369.308 112.93 368.744 113.513 368.099 113.777H368.094Z",
    fill: "url(#paint10_radial_10322_9888)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.252 93.9126C297.926 94.2715 298.296 95.4057 298.889 95.5875C299.316 95.7168 301.83 94.8171 302.485 94.6352C303.144 94.4534 304.325 94.2237 304.643 93.6207C305.274 92.4244 303.931 91.496 306.047 91.4912C306.806 91.4912 308.001 91.8645 308.884 91.9698C309.875 92.0894 310.71 92.3861 311.588 92.7546C312.342 93.0704 312.921 93.4772 313.675 93.4293C313.708 93.5777 313.76 93.7164 313.988 93.6973C315.226 93.8074 316.668 95.3626 317.18 96.358C317.612 97.1907 317.569 97.8989 318.153 98.7268C318.608 99.3728 319.211 99.8514 319.704 100.445C321.137 102.172 321.511 103.675 321.293 105.895C321.132 107.542 322.057 109.451 321.53 110.877C321.137 111.944 320.074 112.308 319.453 113.16C318.921 113.892 318.869 114.887 318.248 115.576C316.867 117.112 314.932 116.581 313.2 116.754C312.551 116.821 311.863 117.318 311.108 117.06C310.302 116.782 309.975 115.706 308.945 115.514C308.039 115.347 307.722 115.926 307.029 116.012C306.298 116.098 305.625 115.725 304.913 115.816C302.883 116.069 303.893 118.854 302.836 120.367C302.352 121.06 301.588 121.491 301.166 122.338C300.578 123.52 300.701 124.482 300.431 125.707C300.265 126.473 299.207 127.305 299.216 127.894C299.23 128.717 300.117 128.727 300.393 129.382C300.81 130.368 300.412 131.88 299.999 132.794C299.425 134.058 299.216 134.756 298.917 136.12C298.789 136.709 298.433 138.154 297.817 138.661C292.148 131.627 288.752 122.659 288.752 112.887C288.752 107.02 289.98 101.435 292.186 96.3915C293.519 94.4869 295.236 92.8359 297.262 93.9174L297.252 93.9126Z",
    fill: "url(#paint11_radial_10322_9888)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 73.1152C326.682 72.4308 328.48 73.1008 330.662 73.5506C331.653 73.7564 335.458 73.5267 335.591 74.9528C336.174 75.594 334.784 75.4361 334.424 75.3404C333.845 75.1873 333.394 75.0054 332.806 75.2782C332.768 76.0199 333.076 76.8669 333.408 77.4651C333.888 78.3265 334.661 78.6376 334.405 79.8578C334.22 80.724 333.029 81.0494 332.151 80.7623C331.445 80.5326 330.871 79.6138 330.301 79.1257C329.642 78.561 328.949 78.2499 328.11 78.0872C327.009 77.8719 325.885 77.714 324.799 77.4029C323.452 77.0201 322.133 76.13 320.733 76.0438C320.103 74.7661 323.746 73.3496 324.5 73.1104V73.1152Z",
    fill: "url(#paint12_radial_10322_9888)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M316.896 90.6781C317.057 91.8122 316.72 92.4535 315.458 92.6162C314.486 92.7406 313.419 92.1663 312.584 91.6399C311.901 91.2093 311.773 90.9221 311.497 90.2617C311.161 89.4482 310.549 89.5248 310.032 88.9505C309.51 88.3667 309.685 87.8355 308.694 87.4623C307.883 87.156 307.133 87.2373 306.36 87.5819C304.956 88.2136 302.352 89.654 300.881 88.405C300.089 87.735 300.407 86.7684 300.929 85.974C302.039 84.2847 303.784 82.2988 305.796 81.7676C306.934 81.4661 308.319 81.5475 309.382 82.0499C310.259 82.4663 310.544 83.4616 311.412 83.921C312.399 84.4426 313.395 84.1172 312.721 85.5433C312.531 85.9453 312.237 86.1319 312.266 86.7014C312.285 87.1368 312.309 87.5005 312.731 87.7207C313.879 88.3141 315.454 87.3043 316.611 88.07V88.0796C317.09 88.3236 317.043 88.7878 316.995 89.2424C316.934 89.8119 316.81 90.0655 316.896 90.6781Z",
    fill: "url(#paint13_radial_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 72C337.953 72 345.998 74.7564 352.592 79.4461C347.649 76.8285 342.023 75.345 336.055 75.345C316.393 75.345 300.454 91.4241 300.454 111.26C300.454 131.095 316.393 147.174 336.055 147.174C347.99 147.174 358.55 141.25 365.011 132.162C358.18 145.016 344.736 153.764 329.267 153.764C306.887 153.764 288.742 135.46 288.742 112.882C288.742 90.3043 306.887 72 329.267 72Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328.646 159.411V159.512C328.855 159.512 329.059 159.512 329.267 159.512C330.173 159.512 331.07 159.483 331.962 159.43V164.455C331.07 164.503 330.169 164.532 329.267 164.532C329.059 164.532 328.855 164.532 328.646 164.532V181.998H326.573V164.465V159.44V159.416H328.646V159.411Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M295.478 189.731H363.056V185.549C340.254 178.859 317.731 178.859 295.478 185.549V189.731Z",
    fill: "url(#paint14_linear_10322_9888)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 162.549C356.415 162.549 378.502 140.268 378.502 112.886C378.502 99.6019 373.369 87.1167 364.048 77.7324L360.537 81.288C368.915 89.7247 373.53 100.947 373.53 112.886C373.53 137.503 353.678 157.534 329.272 157.534C317.437 157.534 306.313 152.878 297.95 144.427L294.425 147.973C303.728 157.376 316.104 162.554 329.267 162.554V162.549Z",
    fill: "url(#paint15_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.006 180.533C324.571 181.883 322.114 185.553 322.114 185.553H363.056V189.736H295.478V185.553C306.583 182.213 317.764 180.538 329.006 180.533Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.734 111.212C373.734 113.384 373.577 115.524 373.279 117.615C373.44 116.06 373.525 114.48 373.525 112.882C373.525 100.938 368.914 89.7157 360.532 81.2837L361.457 80.3506C369.379 88.6964 373.734 99.612 373.734 111.212Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.364 147.021C304.581 155.965 316.654 160.875 329.476 160.875C354.252 160.875 374.816 142.312 378.217 118.251C375.556 143.121 354.617 162.545 329.272 162.545C316.104 162.545 303.732 157.367 294.43 147.964L295.369 147.016L295.364 147.021Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M334.959 82.1645C320.871 93.994 351.937 110.245 359.56 104.168C371.386 94.7454 347.25 71.8471 334.959 82.1645Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M359.574 110.418C348.522 109.657 352.416 125.014 357.719 125.224C365.95 125.55 368.236 111.016 359.574 110.418Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M186 194.952L277.13 194.685L231.434 148.85L186 194.948V194.952ZM255.988 186.195L207.09 186.339L231.468 161.603L255.988 186.195Z",
    fill: "url(#paint16_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.384 156.013L227.583 155.812L226.07 154.295L225.87 154.491L227.384 156.013Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M226.155 157.262L226.349 157.061L224.836 155.544L224.642 155.74L226.155 157.262Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M223.347 160.105L223.542 159.908L222.028 158.387L221.834 158.588L223.347 160.105Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M222.113 161.354L222.312 161.158L220.799 159.636L220.6 159.837L222.113 161.354Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M219.305 164.196L219.504 163.999L217.991 162.482L217.797 162.679L219.305 164.196Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M218.076 165.445L218.271 165.248L216.758 163.731L216.563 163.928L218.076 165.445Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M215.268 168.292L215.463 168.091L213.954 166.574L213.755 166.77L215.268 168.292Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M214.035 169.541L214.234 169.34L212.721 167.823L212.522 168.019L214.035 169.541Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.231 172.384L211.426 172.188L209.912 170.666L209.718 170.867L211.231 172.384Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.998 173.633L210.192 173.432L208.679 171.915L208.485 172.111L209.998 173.633Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.19 176.476L207.389 176.28L205.876 174.758L205.677 174.959L207.19 176.476Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M205.957 177.725L206.156 177.529L204.643 176.007L204.443 176.208L205.957 177.725Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M203.12 180.606L203.314 180.405L201.801 178.888L201.606 179.084L203.12 180.606Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M201.887 181.855L202.081 181.654L200.568 180.137L200.373 180.333L201.887 181.855Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.064 184.711L199.258 184.515L197.745 182.998L197.55 183.194L199.064 184.711Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.831 185.96L198.026 185.764L196.512 184.242L196.318 184.443L197.831 185.96Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.942 188.889L195.137 188.693L193.623 187.171L193.429 187.372L194.942 188.889Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M193.709 190.138L193.903 189.942L192.395 188.42L192.195 188.621L193.709 190.138Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M230.035 155.894L230.301 155.626L227.516 152.831L227.25 153.099L230.035 155.894Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M225.979 160.004L226.245 159.736L223.46 156.937L223.195 157.209L225.979 160.004Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M221.924 164.115L222.189 163.847L219.405 161.048L219.139 161.321L221.924 164.115Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M217.868 168.226L218.134 167.958L215.349 165.158L215.083 165.431L217.868 168.226Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M213.812 172.337L214.078 172.069L211.293 169.27L211.027 169.538L213.812 172.337Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M209.756 176.447L210.022 176.179L207.237 173.38L206.971 173.648L209.756 176.447Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M205.7 180.558L205.966 180.285L203.177 177.49L202.911 177.758L205.7 180.558Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.644 184.668L201.91 184.395L199.121 181.601L198.855 181.869L201.644 184.668Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M197.589 188.775L197.854 188.507L195.065 185.712L194.8 185.98L197.589 188.775Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M193.528 192.885L193.794 192.617L191.009 189.822L190.748 190.09L193.528 192.885Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M226.297 194.837C226.297 194.459 226.297 193.268 226.287 191.21H228.598L228.583 186.276L255.987 186.195L235.153 165.297C235.092 165.062 235.011 164.837 235.006 164.584L234.973 152.84C234.973 152.711 235.03 152.606 235.044 152.481L277.125 194.689L226.292 194.837H226.297Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 185.697L255.494 185.702L231.477 161.612L231.98 161.104L256.5 185.697Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M231.43 148.854L231.79 149.213L187.2 194.455L276.632 194.192L277.125 194.689L186 194.953L231.43 148.854Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M207.044 187.04L234.177 186.959L234.175 186.303L207.042 186.385L207.044 187.04Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M372.889 192.634L374.069 192.324L373.25 189.147L372.07 189.457L372.889 192.634Z",
    fill: "url(#paint17_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M372.885 192.64L373.486 192.482L372.667 189.305L372.066 189.463L372.885 192.64Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M369.574 194.579L377.78 194.555C378.435 194.555 378.966 194.014 378.966 193.354C378.966 192.693 378.43 192.157 377.775 192.157L369.569 192.181C368.914 192.181 368.383 192.722 368.383 193.382C368.383 194.043 368.919 194.579 369.574 194.579Z",
    fill: "url(#paint18_linear_10322_9888)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M372.729 189.564C373.853 189.267 374.526 188.109 374.232 186.975L373.782 185.223C373.488 184.089 372.34 183.41 371.215 183.706C370.091 184.003 369.418 185.161 369.712 186.295L370.162 188.047C370.456 189.181 371.604 189.86 372.729 189.564Z",
    fill: "url(#paint19_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M371.22 183.707C371.486 183.635 371.751 183.63 372.012 183.664C372.306 183.841 372.629 183.97 372.966 184.066C373.35 184.343 373.658 184.731 373.786 185.228L374.199 186.822C373.711 187.353 373.108 187.789 372.363 187.985C372.017 188.076 371.671 188.1 371.325 188.095C371.794 188.865 372.691 189.291 373.601 189.062C373.355 189.286 373.075 189.478 372.729 189.569C371.604 189.866 370.456 189.181 370.162 188.052L369.712 186.3C369.418 185.166 370.091 184.008 371.215 183.711L371.22 183.707Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M372.131 187.252C374.223 186.702 375.475 184.549 374.93 182.443L353.65 99.8848L346.079 101.871L367.359 184.429C367.904 186.539 370.039 187.803 372.126 187.252H372.131Z",
    fill: "url(#paint20_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M346.084 101.871L353.654 99.8848L354.461 103.014C353.621 104.469 352.383 105.642 350.903 106.407L370.015 180.548C370.561 182.658 372.695 183.922 374.783 183.371C374.877 183.348 374.963 183.3 375.058 183.271C375.134 185.089 373.952 186.779 372.136 187.252C370.044 187.803 367.909 186.535 367.368 184.429L347.502 107.364L346.088 101.871H346.084Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M369.564 192.186L372.842 192.177C372.187 192.177 371.656 192.718 371.656 193.378C371.656 194.038 372.192 194.574 372.847 194.569L369.569 194.579C368.914 194.579 368.378 194.048 368.378 193.387C368.378 192.727 368.905 192.186 369.56 192.186H369.564Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M369.569 193.766L377.776 193.742C378.288 193.742 378.715 193.407 378.881 192.947C378.928 193.076 378.961 193.21 378.961 193.354C378.961 194.014 378.435 194.555 377.776 194.555L369.569 194.579C368.914 194.579 368.378 194.048 368.378 193.388C368.378 193.244 368.412 193.11 368.459 192.981C368.625 193.44 369.052 193.77 369.569 193.77V193.766Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M378.16 192.699C378.307 192.244 375.522 192.354 375.423 192.593C375.271 192.967 378.032 193.096 378.16 192.699Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M375.072 192.698C375.124 192.368 374.156 192.45 374.123 192.622C374.071 192.89 375.029 192.986 375.072 192.698Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.476 191.152C320.549 191.75 322.707 190.535 323.3 188.444L324.215 185.214C324.808 183.122 323.604 180.945 321.531 180.347C319.458 179.749 317.299 180.964 316.706 183.055L315.791 186.286C315.198 188.377 316.403 190.554 318.476 191.152Z",
    fill: "url(#paint21_linear_10322_9888)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M317.683 193.947C319.206 194.387 320.795 193.492 321.232 191.956L321.905 189.577C322.342 188.041 321.455 186.438 319.932 185.998C318.409 185.558 316.82 186.453 316.384 187.989L315.71 190.367C315.274 191.903 316.161 193.506 317.683 193.947Z",
    fill: "url(#paint22_linear_10322_9888)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.301 188.228C321.378 188.826 323.541 187.611 324.134 185.515L347.762 101.971L340.244 99.8076L316.616 183.352C316.023 185.448 317.228 187.63 319.305 188.228H319.301Z",
    fill: "url(#paint23_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.611 183.352L339.371 102.88L340.239 99.8076L347.758 101.971L346.24 107.34C344.717 107.215 343.313 106.694 342.118 105.88L320.719 181.548C320.126 183.644 321.331 185.826 323.409 186.424C323.504 186.453 323.603 186.457 323.698 186.477C322.806 187.951 321.028 188.721 319.301 188.223C317.223 187.625 316.023 185.443 316.616 183.347L316.611 183.352Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M344.366 92.826L349.503 92.8117L349.47 81.2931C349.47 79.8623 348.313 78.7042 346.894 78.709C345.476 78.709 344.328 79.8766 344.333 81.3075L344.366 92.826Z",
    fill: "url(#paint24_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M346.895 78.709C347.046 78.709 347.179 78.7712 347.326 78.7951C346.52 79.2354 345.955 80.068 345.96 81.0538L345.974 85.8967C346.287 85.8536 346.596 85.8106 346.918 85.8058C347.82 85.8058 348.669 85.9781 349.489 86.2317L349.508 92.5628V92.8117L344.371 92.826L344.352 86.246L344.338 81.3075C344.338 79.8766 345.481 78.7138 346.899 78.709H346.895Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M353.099 102.557C356.501 99.1262 356.501 93.5632 353.099 90.132C349.698 86.7009 344.184 86.7009 340.783 90.132C337.381 93.5632 337.381 99.1262 340.783 102.557C344.184 105.989 349.698 105.989 353.099 102.557Z",
    fill: "url(#paint25_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M342.255 96.0993C342.265 98.8557 344.504 101.081 347.265 101.076C350.025 101.067 352.255 98.827 352.245 96.0706C352.236 93.3142 349.997 91.089 347.236 91.0938C344.475 91.1033 342.246 93.3429 342.255 96.0993Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 99.6879C352.085 97.8415 352.085 94.8479 350.255 93.0015C348.425 91.1551 345.457 91.1551 343.627 93.0015C341.797 94.8479 341.797 97.8415 343.627 99.6879C345.457 101.534 348.425 101.534 350.255 99.6879Z",
    fill: "url(#paint26_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M345.486 87.7061C342.047 88.6823 339.513 91.8407 339.523 95.6212C339.537 100.167 343.199 103.838 347.706 103.828C351.453 103.819 354.57 101.244 355.518 97.7698C354.845 101.933 351.292 105.12 346.975 105.135C342.165 105.149 338.252 101.225 338.237 96.3725C338.223 92.0129 341.368 88.4143 345.49 87.7108L345.486 87.7061Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M346.781 93.0275C345.026 94.511 348.911 96.5256 349.859 95.7648C351.33 94.5828 348.313 91.7354 346.781 93.0275Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M349.859 96.5451C348.479 96.4542 348.972 98.3684 349.632 98.3923C350.661 98.4306 350.941 96.6169 349.859 96.5451Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M347.212 79.3406C346.003 80.0202 348.038 81.5994 348.688 81.2548C349.698 80.7189 348.27 78.7473 347.212 79.3406Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M346.928 91.6152C346.985 91.6152 347.037 91.6296 347.094 91.6296C344.807 91.7253 342.986 93.6155 342.991 95.9461C342.995 98.334 344.921 100.258 347.284 100.253C349.651 100.248 351.558 98.3053 351.553 95.9221C351.553 95.6829 351.52 95.4484 351.482 95.2187C351.567 95.5776 351.629 95.9461 351.629 96.3289C351.638 98.9417 349.542 101.062 346.956 101.071C344.366 101.081 342.265 98.9657 342.255 96.3576C342.246 93.7495 344.342 91.6248 346.928 91.6152Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M292.618 151.964L335.676 151.84L355.186 194.636L312.954 194.76L292.722 153.424C292.49 152.955 292.475 152.438 292.613 151.969L292.618 151.964Z",
    fill: "url(#paint27_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M292.618 151.964L335.676 151.84L355.186 194.636L312.954 194.76L292.722 153.424C292.49 152.955 292.475 152.438 292.613 151.969L292.618 151.964Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M294.055 156.132L292.727 153.419C292.495 152.95 292.48 152.433 292.618 151.964L335.676 151.84L337.573 156.003L294.055 156.132Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.676 151.84L292.618 151.965C292.77 151.453 293.111 151.003 293.624 150.749L300.986 147.083C301.099 147.026 301.583 146.892 301.702 146.892C301.745 146.892 301.783 146.892 301.825 146.892L344.281 146.768L344.305 154.735L337.009 154.754L335.681 151.84H335.676Z",
    fill: "url(#paint28_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M335.676 151.84L292.618 151.965C292.77 151.453 293.111 151.003 293.624 150.749L300.986 147.083C301.427 146.863 301.697 146.892 301.825 146.892L344.281 146.768L335.676 151.84Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M326.895 150.653L334.257 146.987C334.699 146.767 334.969 146.796 335.097 146.796L339.134 146.786C339.01 146.786 338.735 146.758 338.294 146.978L330.932 150.643C330.42 150.897 330.078 151.352 329.926 151.859L325.89 151.869C326.041 151.356 326.383 150.907 326.895 150.653Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M297.167 150.739L304.529 147.073C304.97 146.853 305.241 146.882 305.369 146.882L309.406 146.872C309.282 146.872 309.007 146.844 308.566 147.064L301.204 150.729C300.692 150.983 300.35 151.438 300.198 151.945L296.161 151.954C296.313 151.442 296.655 150.993 297.167 150.739Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M356.581 192.401L363.488 188.96L364.095 190.195C365.418 189.535 366.097 189.2 366.097 189.2L345.865 147.863C345.381 146.877 344.195 146.47 343.218 146.959L335.856 150.624C334.879 151.112 334.476 152.309 334.96 153.294L355.191 194.631C355.191 194.631 355.874 194.291 357.188 193.636L356.581 192.401Z",
    fill: "url(#paint29_linear_10322_9888)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M345.051 151.259L363.504 188.958L356.597 192.399L338.144 154.7C337.837 154.073 338.091 153.317 338.712 153.008L343.374 150.685C343.995 150.376 344.744 150.632 345.051 151.259Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M345.018 151.207L338.11 154.647L356.582 192.385L363.49 188.944L345.018 151.207Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M343.28 150.558L338.65 152.864C338.019 153.175 337.763 153.946 338.076 154.577L356.586 192.397L363.493 188.956L344.983 151.137C344.675 150.5 343.911 150.242 343.285 150.558H343.28Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M344.077 153.835C343.764 153.199 343.005 152.941 342.374 153.252L338.394 155.233L338.071 154.572C337.763 153.936 338.019 153.17 338.645 152.859L343.275 150.553C343.906 150.242 344.665 150.5 344.973 151.132L363.483 188.951L361.695 189.841L344.072 153.831L344.077 153.835Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M340.984 153.825C340.984 153.825 341.942 155.888 343.384 158.979C344.859 162.056 346.828 166.152 348.796 170.254C350.827 174.321 352.857 178.394 354.38 181.442C355.94 184.476 356.979 186.495 356.979 186.495C356.979 186.495 356.021 184.433 354.579 181.341C353.104 178.264 351.135 174.168 349.166 170.067C347.136 165.999 345.106 161.932 343.583 158.879C342.022 155.845 340.984 153.825 340.984 153.825Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M355.561 179.451C355.561 179.451 355.803 180.078 356.192 181.002C356.581 181.925 357.15 183.136 357.724 184.342C358.326 185.538 358.929 186.73 359.422 187.606C359.911 188.481 360.262 189.056 360.262 189.056C360.262 189.056 360.024 188.429 359.631 187.505C359.242 186.581 358.673 185.371 358.094 184.165C357.491 182.968 356.889 181.777 356.396 180.906C355.907 180.03 355.556 179.456 355.556 179.456L355.561 179.451Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M341.335 158.185C341.335 158.185 342.056 159.759 343.133 162.123C344.224 164.482 345.728 167.598 347.236 170.718C348.773 173.823 350.31 176.924 351.501 179.231C352.705 181.533 353.507 183.069 353.507 183.069C353.507 183.069 352.786 181.494 351.709 179.13C350.618 176.771 349.114 173.656 347.606 170.536C346.069 167.43 344.532 164.329 343.337 162.022C342.132 159.721 341.33 158.185 341.33 158.185H341.335Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M329.348 163.947L329.315 152.926H331.255C331.25 150.811 331.246 149.729 331.246 149.729L242.098 149.988C240.552 149.988 239.3 151.261 239.304 152.826L239.338 164.569C239.338 166.129 240.599 167.393 242.151 167.388L331.298 167.129C331.298 167.129 331.298 166.043 331.288 163.942H329.348V163.947Z",
    fill: "url(#paint30_linear_10322_9888)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M329.348 163.947L245.902 164.191C244.921 164.191 244.124 163.396 244.124 162.406L244.105 154.969C244.105 153.979 244.892 153.175 245.874 153.175L329.319 152.931L329.353 163.952L329.348 163.947Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M329.324 152.916L284.697 153.05L284.729 164.071L329.357 163.937L329.324 152.916Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M329.324 152.916L284.697 153.05L284.729 164.071L329.357 163.937L329.324 152.916Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M286.935 159.865C286.935 159.865 289.136 159.927 292.437 160.013C295.739 160.085 300.141 160.1 304.543 160.109C308.945 160.076 313.347 160.037 316.649 159.946C319.951 159.836 322.152 159.765 322.152 159.765C322.152 159.765 319.951 159.702 316.649 159.616C313.347 159.544 308.945 159.53 304.543 159.521C300.141 159.554 295.739 159.597 292.437 159.683C289.136 159.793 286.935 159.865 286.935 159.865Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M312.37 157.18C312.37 157.18 313.309 157.261 314.723 157.338C316.137 157.415 318.015 157.439 319.898 157.453C321.782 157.429 323.66 157.395 325.074 157.309C326.487 157.233 327.427 157.137 327.427 157.137C327.427 157.137 326.487 157.046 325.074 156.979C323.66 156.903 321.782 156.879 319.898 156.864C318.015 156.888 316.137 156.926 314.723 157.008C313.314 157.094 312.37 157.18 312.37 157.18Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M292.656 162.133C292.656 162.133 294.093 162.214 296.251 162.286C298.41 162.363 301.284 162.382 304.159 162.391C307.034 162.363 309.908 162.324 312.062 162.238C314.215 162.162 315.653 162.061 315.653 162.061C315.653 162.061 314.215 161.97 312.057 161.903C309.899 161.827 307.024 161.807 304.149 161.798C301.275 161.827 298.4 161.865 296.247 161.951C294.093 162.037 292.656 162.128 292.656 162.128V162.133Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M329.32 152.921L284.692 153.055L284.699 155.557L329.327 155.424L329.32 152.921Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M242.098 149.993L282.813 149.873L282.865 167.273L242.151 167.393C240.604 167.393 239.342 166.134 239.338 164.574L239.304 152.83C239.304 151.27 240.552 149.997 242.098 149.993Z",
    fill: "url(#paint31_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M242.098 149.993L282.457 149.873C280.911 149.873 279.658 151.146 279.663 152.711L279.696 164.454C279.696 166.014 280.958 167.278 282.509 167.273L242.151 167.393C240.604 167.393 239.342 166.134 239.338 164.574L239.304 152.83C239.304 151.27 240.552 149.997 242.098 149.993Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M270.152 164.483L270.119 152.74C270.119 151.18 271.366 149.907 272.913 149.902L275.669 149.893C274.122 149.893 272.87 151.166 272.875 152.73L272.908 164.474C272.908 166.034 274.17 167.297 275.721 167.292L272.965 167.302C271.418 167.302 270.157 166.043 270.152 164.483Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M243.868 164.56L243.834 152.816C243.834 151.256 245.082 149.983 246.628 149.978L249.384 149.969C247.838 149.969 246.586 151.242 246.59 152.807L246.624 164.55C246.624 166.11 247.886 167.373 249.437 167.369L246.681 167.378C245.134 167.378 243.872 166.12 243.868 164.56Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M279.697 164.071V164.454C279.701 166.014 280.958 167.278 282.51 167.273L242.151 167.392C240.604 167.392 239.342 166.134 239.338 164.574V164.191L279.697 164.071Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M325.719 147.758L325.7 141.001H326.891C326.891 139.704 326.886 139.044 326.886 139.044L245.319 139.283C244.37 139.283 243.602 140.063 243.607 141.02L243.626 148.222C243.626 149.179 244.399 149.955 245.348 149.95L326.914 149.711C326.914 149.711 326.914 149.046 326.91 147.753H325.719V147.758Z",
    fill: "url(#paint32_linear_10322_9888)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M247.633 141.221L325.708 140.988L325.728 147.745L247.653 147.978C247.05 147.98 246.565 147.489 246.563 146.886L246.55 142.325C246.548 141.718 247.035 141.228 247.633 141.226L247.633 141.221Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.548 147.861L325.723 147.749L325.703 140.992Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.548 147.861L325.723 147.749L325.703 140.992Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M289.9 145.284C289.9 145.284 291.864 145.318 294.805 145.366C297.751 145.38 301.674 145.399 305.601 145.418C309.529 145.375 313.452 145.337 316.398 145.304C319.344 145.237 321.303 145.194 321.303 145.194C321.303 145.194 319.339 145.16 316.398 145.112C313.452 145.098 309.529 145.079 305.601 145.06C301.674 145.103 297.751 145.141 294.805 145.174C291.859 145.241 289.9 145.284 289.9 145.284Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M315.311 143.609C315.311 143.609 315.89 143.667 316.753 143.7C317.617 143.719 318.774 143.748 319.927 143.777C322.237 143.786 324.542 143.581 324.542 143.581C324.542 143.581 322.232 143.389 319.927 143.413C318.774 143.447 317.621 143.48 316.753 143.504C315.89 143.547 315.311 143.605 315.311 143.605V143.609Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M293.41 146.676C293.41 146.676 294.904 146.71 297.148 146.763C299.392 146.777 302.38 146.801 305.369 146.82C311.346 146.82 317.327 146.605 317.327 146.605C317.327 146.605 311.35 146.428 305.369 146.456C302.38 146.495 299.392 146.533 297.148 146.562C294.904 146.629 293.41 146.672 293.41 146.672V146.676Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.532 142.635L325.708 142.524L325.703 140.992Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M245.314 139.284L287.371 139.159L287.4 149.826L245.343 149.95C244.394 149.95 243.621 149.18 243.621 148.223L243.602 141.021C243.602 140.064 244.365 139.284 245.314 139.284Z",
    fill: "url(#paint33_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M245.314 139.283L287.153 139.163C286.204 139.163 285.436 139.943 285.441 140.9L285.46 148.102C285.46 149.059 286.233 149.835 287.182 149.83L245.343 149.949C244.394 149.949 243.621 149.179 243.621 148.222L243.602 141.02C243.602 140.063 244.365 139.283 245.314 139.283Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M279.611 148.117L279.592 140.915C279.592 139.958 280.356 139.178 281.304 139.178H282.993C282.044 139.178 281.276 139.953 281.281 140.91L281.3 148.112C281.3 149.069 282.073 149.844 283.022 149.84H281.333C280.384 149.849 279.611 149.074 279.611 148.117Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M275.033 148.132L275.014 140.929C275.014 139.972 275.778 139.192 276.727 139.192H278.416C277.467 139.192 276.698 139.968 276.703 140.925L276.722 148.127C276.722 149.084 277.495 149.859 278.444 149.854H276.755C275.807 149.864 275.033 149.089 275.033 148.132Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M251.481 148.198L251.462 140.996C251.462 140.039 252.226 139.259 253.174 139.259H254.863C253.914 139.259 253.146 140.034 253.151 140.991L253.17 148.193C253.17 149.15 253.943 149.926 254.892 149.921H253.203C252.254 149.93 251.481 149.155 251.481 148.198Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M246.903 148.213L246.884 141.011C246.884 140.053 247.648 139.273 248.597 139.273H250.286C249.337 139.273 248.568 140.049 248.573 141.006L248.592 148.208C248.592 149.165 249.365 149.94 250.314 149.935H248.625C247.677 149.945 246.903 149.17 246.903 148.213Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M285.464 147.863V148.098C285.464 149.055 286.238 149.83 287.186 149.825L245.347 149.945C244.399 149.945 243.625 149.174 243.625 148.217V147.983L285.464 147.858V147.863Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M232.929 191.19L232.872 170.962H230.561C230.552 168.455 230.552 167.168 230.552 167.168L336.762 166.856C338.607 166.852 340.106 168.354 340.111 170.216L340.173 191.305C340.177 193.167 338.688 194.679 336.843 194.684L230.633 194.995C230.633 194.995 230.633 193.698 230.623 191.195H232.933L232.929 191.19Z",
    fill: "url(#paint34_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M335.167 190.893L235.75 191.191L235.691 170.963L335.107 170.665C336.274 170.662 337.226 171.616 337.229 172.793L337.276 188.752C337.28 189.93 336.334 190.89 335.167 190.893Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M232.929 191.19L332.346 190.898C333.513 190.898 334.457 189.936 334.457 188.759L334.409 172.799C334.409 171.622 333.456 170.67 332.289 170.67L232.872 170.962L232.929 191.19Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M230.557 170.972C230.548 168.455 230.548 167.173 230.548 167.173L284.744 167.015L284.824 194.842L230.628 195C230.628 195 230.628 193.703 230.619 191.2H232.929L232.872 170.967H230.562L230.557 170.972Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.799L232.878 170.958L232.937 191.186L286.104 191.027L286.044 170.799Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.799L232.878 170.958L232.937 191.186L286.104 191.027L286.044 170.799Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M284.241 170.814L332.289 170.675C333.456 170.675 334.405 171.622 334.409 172.804L334.419 175.829C334.419 174.652 333.465 173.699 332.298 173.699L284.25 173.838L284.241 170.814Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M330.833 176.379C330.833 176.379 329.429 176.25 327.327 176.159C326.274 176.125 325.05 176.054 323.736 176.044C322.422 176.03 321.018 176.015 319.619 176.001C318.215 176.025 316.816 176.044 315.502 176.068C314.188 176.087 312.959 176.168 311.911 176.207C309.809 176.312 308.405 176.451 308.405 176.451C308.405 176.451 309.809 176.58 311.911 176.676C312.964 176.704 314.188 176.781 315.502 176.791C316.816 176.805 318.22 176.819 319.619 176.834C321.023 176.81 322.422 176.786 323.736 176.767C325.05 176.748 326.279 176.666 327.327 176.628C329.429 176.523 330.833 176.384 330.833 176.384V176.379Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M324.187 187.314C324.187 187.314 322.133 187.199 319.049 187.099C317.508 187.065 315.71 187.027 313.784 186.988C311.858 186.974 309.804 186.965 307.75 186.95C305.696 186.974 303.642 186.998 301.716 187.022C299.79 187.041 297.992 187.127 296.451 187.166C293.367 187.285 291.313 187.414 291.313 187.414C291.313 187.414 293.367 187.529 296.451 187.635C297.992 187.663 299.79 187.735 301.716 187.745C303.642 187.754 305.696 187.768 307.75 187.783C309.804 187.759 311.858 187.735 313.784 187.711C315.71 187.658 317.508 187.611 319.049 187.568C322.133 187.448 324.187 187.319 324.187 187.319V187.314Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M327.512 180.155C327.512 180.155 325.458 180.04 322.374 179.939C320.833 179.906 319.035 179.868 317.109 179.829C315.183 179.815 313.129 179.805 311.075 179.791C309.021 179.815 306.967 179.839 305.041 179.863C303.115 179.882 301.317 179.968 299.776 180.006C296.692 180.126 294.638 180.255 294.638 180.255C294.638 180.255 296.692 180.37 299.776 180.475C301.317 180.504 303.115 180.576 305.041 180.585C306.967 180.595 309.021 180.609 311.075 180.624C313.129 180.6 315.183 180.576 317.109 180.552C319.035 180.499 320.833 180.451 322.374 180.408C325.458 180.289 327.512 180.159 327.512 180.159V180.155Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M283.425 184.644C283.425 184.644 280.802 184.501 276.869 184.4C274.9 184.362 272.609 184.323 270.152 184.276C267.695 184.261 265.072 184.252 262.448 184.237C259.825 184.266 257.207 184.295 254.745 184.323C252.288 184.347 249.992 184.443 248.028 184.486C244.095 184.611 241.472 184.768 241.472 184.768C241.472 184.768 244.095 184.912 248.028 185.013C249.996 185.046 252.288 185.127 254.745 185.137C257.202 185.151 259.825 185.161 262.448 185.175C265.072 185.147 267.69 185.118 270.152 185.089C272.609 185.032 274.905 184.974 276.869 184.926C280.802 184.802 283.425 184.644 283.425 184.644Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M253.089 175.915C253.089 175.915 251.97 175.82 250.286 175.753C248.602 175.676 246.363 175.652 244.119 175.638C241.875 175.666 239.636 175.7 237.952 175.791C236.273 175.867 235.149 175.973 235.149 175.973C235.149 175.973 236.268 176.068 237.952 176.135C239.636 176.212 241.875 176.236 244.119 176.25C246.363 176.222 248.602 176.188 250.286 176.097C251.965 176.021 253.089 175.915 253.089 175.915Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M275.052 188.181C275.052 188.181 273.34 188.066 270.769 187.98C268.198 187.884 264.773 187.855 261.353 187.841C257.928 187.874 254.503 187.922 251.937 188.032C249.37 188.133 247.658 188.257 247.658 188.257C247.658 188.257 249.37 188.372 251.941 188.458C254.512 188.554 257.937 188.578 261.357 188.597C264.782 188.559 268.207 188.516 270.774 188.405C273.34 188.305 275.052 188.181 275.052 188.181Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M274.241 179.447C274.241 179.447 272.529 179.332 269.958 179.246C267.387 179.15 263.962 179.122 260.542 179.107C257.117 179.141 253.692 179.189 251.126 179.299C248.559 179.399 246.847 179.524 246.847 179.524C246.847 179.524 248.559 179.639 251.13 179.725C253.701 179.82 257.126 179.844 260.547 179.864C263.971 179.825 267.396 179.782 269.963 179.672C272.529 179.572 274.241 179.447 274.241 179.447Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.799L232.878 170.958L232.886 173.939L286.053 173.78L286.044 170.799Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M321.805 173.93C320.444 177.117 320.008 186.329 319.946 191.019H343.28C343.318 186.468 342.972 176.959 341.529 173.533C339.504 168.709 334.381 165.675 334.381 164.512C334.381 163.35 338.484 160.584 340.733 156.416C342.592 152.975 343.247 146.218 343.285 141.083H319.951C319.913 146.261 320.558 153.008 322.251 156.53C324.163 160.502 328.85 163.134 328.85 164.517C328.85 165.9 323.874 169.102 321.805 173.93ZM321.288 189.693C321.426 183.755 322.005 176.825 323.015 174.457C324.12 171.863 326.231 169.69 327.768 168.106C329.262 166.561 330.168 165.632 330.168 164.517C330.168 163.326 329.163 162.383 327.635 160.962C326.189 159.617 324.391 157.937 323.437 155.951C322.014 152.994 321.345 147.251 321.274 142.413H341.947C341.814 147.213 341.14 152.898 339.58 155.784C338.413 157.947 336.705 159.708 335.334 161.124C333.921 162.584 333.072 163.464 333.072 164.517C333.072 165.57 333.869 166.293 335.315 167.666C336.952 169.221 339.196 171.351 340.329 174.05C341.501 176.845 341.942 184.616 341.975 189.693H321.298H321.288Z",
    fill: "url(#paint35_linear_10322_9888)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.966 189.693C341.933 184.611 341.491 176.84 340.32 174.05C339.186 171.351 336.947 169.221 335.306 167.666C333.859 166.292 333.062 165.536 333.062 164.517C333.062 163.498 333.916 162.584 335.325 161.124C336.696 159.708 338.403 157.947 339.57 155.784C341.131 152.893 341.809 147.213 341.937 142.413H321.265C321.336 147.251 322.005 152.994 323.428 155.951C324.381 157.937 326.179 159.617 327.626 160.966C329.153 162.387 330.159 163.33 330.159 164.522C330.159 165.713 329.253 166.57 327.759 168.111C326.222 169.695 324.111 171.867 323.006 174.461C321.995 176.83 321.416 183.759 321.279 189.698H341.956L341.966 189.693Z",
    fill: "url(#paint36_linear_10322_9888)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M319.846 194.995H343.384C343.845 194.995 344.219 194.618 344.219 194.153V190.53C344.219 190.065 343.845 189.688 343.384 189.688H319.846C319.385 189.688 319.012 190.065 319.012 190.53V194.153C319.012 194.618 319.385 194.995 319.846 194.995Z",
    fill: "url(#paint37_linear_10322_9888)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M319.846 142.441H343.384C343.845 142.441 344.219 142.064 344.219 141.599V137.977C344.219 137.511 343.845 137.134 343.384 137.134H319.846C319.385 137.134 319.012 137.511 319.012 137.977V141.599C319.012 142.064 319.385 142.441 319.846 142.441Z",
    fill: "url(#paint38_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M319.808 189.693H328.916V190.636C328.916 191.124 329.271 191.517 329.713 191.517H344.219V194.115C344.219 194.603 343.863 194.996 343.422 194.996H319.808C319.367 194.996 319.011 194.598 319.011 194.115V190.574C319.011 190.086 319.367 189.693 319.808 189.693Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M319.808 137.135H343.422C343.863 137.135 344.219 137.532 344.219 138.015V140.561H329.713C329.271 140.561 328.916 140.958 328.916 141.442V142.437H319.808C319.367 142.437 319.011 142.04 319.011 141.557V138.015C319.011 137.527 319.367 137.135 319.808 137.135Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M318.438 194.995H344.793C345.139 194.995 345.419 194.712 345.419 194.363V192.913C345.419 192.565 345.139 192.282 344.793 192.282H318.438C318.092 192.282 317.811 192.565 317.811 192.913V194.363C317.811 194.712 318.092 194.995 318.438 194.995Z",
    fill: "url(#paint39_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M318.409 192.287H328.314C327.982 192.287 327.716 192.584 327.716 192.948V194.34C327.716 194.704 327.982 195 328.314 195H318.409C318.077 195 317.811 194.704 317.811 194.34V192.948C317.811 192.584 318.077 192.287 318.409 192.287Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M318.438 139.849H344.793C345.139 139.849 345.419 139.566 345.419 139.217V137.767C345.419 137.418 345.139 137.135 344.793 137.135H318.438C318.092 137.135 317.811 137.418 317.811 137.767V139.217C317.811 139.566 318.092 139.849 318.438 139.849Z",
    fill: "url(#paint40_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M328.85 164.512C328.85 163.129 324.163 160.497 322.251 156.526C320.553 153.003 319.908 146.256 319.95 141.078H343.284C343.275 142.164 343.242 143.322 343.171 144.504H328.655C328.655 144.504 327.929 153.147 329.642 158.32C330.851 161.971 331.506 163.321 331.506 164.953C331.506 166.584 327.777 169.054 328.233 191.014H319.95C320.007 186.324 320.444 177.112 321.81 173.925C323.873 169.092 328.854 165.891 328.854 164.512H328.85Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M318.409 137.135H328.314C327.982 137.135 327.716 137.431 327.716 137.795V139.188C327.716 139.551 327.982 139.848 328.314 139.848H318.409C318.077 139.848 317.811 139.551 317.811 139.188V137.795C317.811 137.431 318.077 137.135 318.409 137.135Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M327.631 160.961C326.184 159.616 324.386 157.937 323.433 155.951C322.84 154.716 322.38 152.974 322.038 151.031H341.069C340.704 152.917 340.216 154.592 339.575 155.783C338.408 157.946 336.701 159.707 335.33 161.124C333.916 162.583 332.763 163.684 332.265 164.43C331.634 165.373 331.445 165.287 330.899 164.43C330.434 163.698 329.153 162.387 327.631 160.966V160.961Z",
    fill: "url(#paint41_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M322.247 152.079C322.176 151.735 322.104 151.39 322.038 151.031H341.069C340.998 151.39 340.922 151.739 340.842 152.079H322.247Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M341.743 183.305C341.804 184.492 341.956 187.803 341.966 189.693H321.288C321.335 187.602 321.464 184.941 321.601 183.305C326.193 183.247 328.987 180.429 331.534 180.429C334.082 180.429 337.45 183.329 341.743 183.305Z",
    fill: "url(#paint42_linear_10322_9888)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M331.155 181.103C328.618 181.103 325.046 183.865 321.597 183.305C325.696 183.396 328.983 180.429 331.53 180.429C334.078 180.429 337.446 183.329 341.739 183.305C341.748 183.501 341.762 183.769 341.776 184.061C337.322 184.003 333.812 181.099 331.155 181.099V181.103Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M324.917 151.031C325.169 152.079 325.458 153.017 325.814 153.749C329.315 161.028 335.491 162.301 340.182 153.601C340.453 153.099 340.69 152.496 340.903 151.83C340.562 153.381 340.13 154.764 339.58 155.783C338.413 157.946 336.705 159.707 335.334 161.124C333.921 162.583 332.768 163.684 332.27 164.43C331.639 165.373 331.449 165.287 330.904 164.43C330.439 163.698 329.163 162.387 327.635 160.966C326.189 159.621 324.391 157.941 323.437 155.955C322.844 154.721 322.384 152.979 322.043 151.036H324.922L324.917 151.031Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 183.305C325.6 183.324 328.622 180.778 331.041 180.467C329.694 181.017 328.817 181.764 328.817 182.773C328.817 184.86 332.09 185.941 335.524 185.941C339.333 185.941 341.582 184.554 341.7 183.271C341.715 183.271 341.724 183.271 341.738 183.271C341.8 184.467 341.952 187.793 341.961 189.688H321.284C321.331 187.588 321.488 184.874 321.597 183.3V183.305Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M331.615 167.828C331.956 167.828 332.232 167.55 332.232 167.206C332.232 166.863 331.956 166.584 331.615 166.584C331.275 166.584 330.998 166.863 330.998 167.206C330.998 167.55 331.275 167.828 331.615 167.828Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 179.438C331.752 179.438 332.028 179.159 332.028 178.815C332.028 178.472 331.752 178.193 331.412 178.193C331.071 178.193 330.795 178.472 330.795 178.815C330.795 179.159 331.071 179.438 331.412 179.438Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M330.519 171.603C330.519 171.847 330.714 172.044 330.956 172.044C331.198 172.044 331.392 171.847 331.392 171.603C331.392 171.359 331.198 171.163 330.956 171.163C330.714 171.163 330.519 171.359 330.519 171.603Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M332.313 169.321C332.313 169.503 332.46 169.652 332.64 169.652C332.82 169.652 332.967 169.503 332.967 169.321C332.967 169.14 332.82 168.991 332.64 168.991C332.46 168.991 332.313 169.14 332.313 169.321Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M331.326 177.155C331.507 177.155 331.653 177.007 331.653 176.824C331.653 176.642 331.507 176.494 331.326 176.494C331.145 176.494 330.998 176.642 330.998 176.824C330.998 177.007 331.145 177.155 331.326 177.155Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M329.969 179.892C329.969 180.074 330.116 180.222 330.296 180.222C330.477 180.222 330.624 180.074 330.624 179.892C330.624 179.71 330.477 179.562 330.296 179.562C330.116 179.562 329.969 179.71 329.969 179.892Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M332.602 180.098C332.602 180.28 332.749 180.428 332.929 180.428C333.109 180.428 333.257 180.28 333.257 180.098C333.257 179.916 333.109 179.768 332.929 179.768C332.749 179.768 332.602 179.916 332.602 180.098Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M330.709 168.617C330.89 168.617 331.036 168.47 331.036 168.287C331.036 168.105 330.89 167.957 330.709 167.957C330.528 167.957 330.382 168.105 330.382 168.287C330.382 168.47 330.528 168.617 330.709 168.617Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M331.245 172.805C331.245 172.987 331.393 173.135 331.573 173.135C331.753 173.135 331.9 172.987 331.9 172.805C331.9 172.623 331.753 172.475 331.573 172.475C331.393 172.475 331.245 172.623 331.245 172.805Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M331.577 166.589C331.321 166.646 331.131 166.871 331.131 167.149C331.131 167.465 331.387 167.723 331.7 167.723C331.914 167.723 332.103 167.603 332.198 167.426C332.113 167.666 331.885 167.833 331.62 167.833C331.278 167.833 331.003 167.556 331.003 167.211C331.003 166.881 331.259 166.613 331.582 166.589H331.577Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M331.197 178.231C331.046 178.332 330.946 178.509 330.946 178.705C330.946 179.021 331.202 179.279 331.515 179.279C331.719 179.279 331.895 179.174 331.994 179.011C331.914 179.26 331.681 179.437 331.411 179.437C331.069 179.437 330.794 179.16 330.794 178.815C330.794 178.547 330.965 178.318 331.202 178.231H331.197Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M330.875 171.168C330.733 171.23 330.633 171.374 330.633 171.536C330.633 171.761 330.813 171.943 331.036 171.943C331.164 171.943 331.278 171.881 331.349 171.79C331.278 171.938 331.131 172.044 330.956 172.044C330.714 172.044 330.519 171.848 330.519 171.603C330.519 171.388 330.671 171.211 330.875 171.173V171.168Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M332.592 168.996C332.488 169.044 332.417 169.149 332.417 169.274C332.417 169.441 332.554 169.58 332.721 169.58C332.801 169.58 332.868 169.551 332.924 169.499C332.868 169.594 332.763 169.656 332.645 169.656C332.464 169.656 332.317 169.508 332.317 169.326C332.317 169.159 332.436 169.025 332.592 169.001V168.996Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M331.212 176.514C331.136 176.571 331.088 176.657 331.088 176.758C331.088 176.925 331.226 177.064 331.392 177.064C331.492 177.064 331.577 177.016 331.634 176.94C331.587 177.064 331.468 177.155 331.326 177.155C331.145 177.155 330.998 177.007 330.998 176.825C330.998 176.681 331.089 176.562 331.212 176.514Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M330.182 179.581C330.121 179.638 330.083 179.715 330.083 179.806C330.083 179.973 330.22 180.112 330.386 180.112C330.472 180.112 330.552 180.074 330.605 180.017C330.557 180.136 330.438 180.222 330.301 180.222C330.121 180.222 329.974 180.074 329.974 179.892C329.974 179.753 330.059 179.634 330.182 179.586V179.581Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M332.773 179.811C332.72 179.863 332.687 179.94 332.687 180.021C332.687 180.189 332.825 180.327 332.991 180.327C333.1 180.327 333.195 180.27 333.247 180.179C333.209 180.323 333.081 180.433 332.929 180.433C332.749 180.433 332.602 180.284 332.602 180.102C332.602 179.978 332.673 179.868 332.773 179.811Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M330.652 167.962C330.552 168.01 330.486 168.115 330.486 168.235C330.486 168.402 330.623 168.541 330.79 168.541C330.87 168.541 330.941 168.507 330.993 168.46C330.937 168.555 330.832 168.622 330.714 168.622C330.533 168.622 330.386 168.474 330.386 168.292C330.386 168.129 330.505 167.995 330.657 167.967L330.652 167.962Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M331.402 172.522C331.359 172.575 331.331 172.642 331.331 172.719C331.331 172.886 331.468 173.025 331.634 173.025C331.748 173.025 331.843 172.963 331.895 172.872C331.867 173.025 331.734 173.14 331.573 173.14C331.392 173.14 331.245 172.991 331.245 172.81C331.245 172.69 331.312 172.585 331.407 172.527L331.402 172.522Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M334.329 170.236C330.98 171.743 337.014 178.141 338.816 177.399C341.61 176.251 337.251 168.92 334.329 170.236Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M344.096 193.349C344.101 194.316 331.174 193.814 331.17 193.292C331.17 192.77 344.086 192.383 344.096 193.349Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M344.096 138.307C344.101 139.274 331.174 138.772 331.17 138.25C331.17 137.728 344.086 137.341 344.096 138.307Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M338.669 145.605C335.017 145.289 335.5 153.898 337.355 154.501C339.831 155.31 341.639 145.864 338.669 145.605Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M336.653 155.655C334.893 154.53 332.474 159.588 333.351 160.081C334.708 160.847 338.033 156.54 336.653 155.655Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M36.78 90.336C34.8013 90.336 33.1027 89.916 31.684 89.076C30.2653 88.2173 29.1733 87.032 28.408 85.52C27.6427 83.9893 27.26 82.2253 27.26 80.228C27.26 78.2307 27.6427 76.4667 28.408 74.936C29.1733 73.4053 30.2653 72.2107 31.684 71.352C33.1027 70.4933 34.8013 70.064 36.78 70.064C39.132 70.064 41.0547 70.652 42.548 71.828C44.06 72.9853 45.0027 74.6187 45.376 76.728H41.428C41.1853 75.664 40.6627 74.8333 39.86 74.236C39.076 73.62 38.0307 73.312 36.724 73.312C34.9133 73.312 33.4947 73.928 32.468 75.16C31.4413 76.392 30.928 78.0813 30.928 80.228C30.928 82.3747 31.4413 84.064 32.468 85.296C33.4947 86.5093 34.9133 87.116 36.724 87.116C38.0307 87.116 39.076 86.836 39.86 86.276C40.6627 85.6973 41.1853 84.904 41.428 83.896H45.376C45.0027 85.912 44.06 87.4893 42.548 88.628C41.0547 89.7667 39.132 90.336 36.78 90.336ZM53.3645 90.336C51.6285 90.336 50.2845 89.7947 49.3325 88.712C48.3992 87.6293 47.9325 86.0427 47.9325 83.952V76.112H51.4885V83.616C51.4885 84.8107 51.7312 85.7253 52.2165 86.36C52.7019 86.9947 53.4672 87.312 54.5125 87.312C55.5019 87.312 56.3139 86.9573 56.9485 86.248C57.6019 85.5387 57.9285 84.5493 57.9285 83.28V76.112H61.5125V90H58.3485L58.0685 87.648C57.6392 88.4693 57.0139 89.1227 56.1925 89.608C55.3899 90.0933 54.4472 90.336 53.3645 90.336ZM64.8837 90V76.112H68.0757L68.4117 78.716C68.9157 77.82 69.597 77.1107 70.4557 76.588C71.333 76.0467 72.3597 75.776 73.5357 75.776V79.556H72.5277C71.7437 79.556 71.0437 79.6773 70.4277 79.92C69.8117 80.1627 69.3264 80.5827 68.9717 81.18C68.6357 81.7773 68.4677 82.608 68.4677 83.672V90H64.8837ZM75.6773 90V76.112H78.8693L79.2053 78.716C79.7093 77.82 80.3906 77.1107 81.2493 76.588C82.1266 76.0467 83.1533 75.776 84.3293 75.776V79.556H83.3213C82.5373 79.556 81.8373 79.6773 81.2213 79.92C80.6053 80.1627 80.1199 80.5827 79.7653 81.18C79.4293 81.7773 79.2613 82.608 79.2613 83.672V90H75.6773ZM88.4028 73.956C87.7495 73.956 87.2081 73.76 86.7788 73.368C86.3681 72.976 86.1628 72.4813 86.1628 71.884C86.1628 71.2867 86.3681 70.8013 86.7788 70.428C87.2081 70.036 87.7495 69.84 88.4028 69.84C89.0561 69.84 89.5881 70.036 89.9988 70.428C90.4281 70.8013 90.6428 71.2867 90.6428 71.884C90.6428 72.4813 90.4281 72.976 89.9988 73.368C89.5881 73.76 89.0561 73.956 88.4028 73.956ZM86.6108 90V76.112H90.1948V90H86.6108ZM100.432 90.336C99.013 90.336 97.7623 90.028 96.6797 89.412C95.597 88.796 94.7383 87.9373 94.1037 86.836C93.4877 85.7347 93.1797 84.4747 93.1797 83.056C93.1797 81.6373 93.4877 80.3773 94.1037 79.276C94.7383 78.1747 95.597 77.316 96.6797 76.7C97.7623 76.084 99.013 75.776 100.432 75.776C102.205 75.776 103.698 76.2427 104.912 77.176C106.125 78.0907 106.9 79.36 107.236 80.984H103.456C103.269 80.312 102.896 79.7893 102.336 79.416C101.794 79.024 101.15 78.828 100.404 78.828C99.4143 78.828 98.5743 79.2013 97.8837 79.948C97.193 80.6947 96.8477 81.7307 96.8477 83.056C96.8477 84.3813 97.193 85.4173 97.8837 86.164C98.5743 86.9107 99.4143 87.284 100.404 87.284C101.15 87.284 101.794 87.0973 102.336 86.724C102.896 86.3507 103.269 85.8187 103.456 85.128H107.236C106.9 86.696 106.125 87.956 104.912 88.908C103.698 89.86 102.205 90.336 100.432 90.336ZM115.317 90.336C113.581 90.336 112.237 89.7947 111.285 88.712C110.351 87.6293 109.885 86.0427 109.885 83.952V76.112H113.441V83.616C113.441 84.8107 113.683 85.7253 114.169 86.36C114.654 86.9947 115.419 87.312 116.465 87.312C117.454 87.312 118.266 86.9573 118.901 86.248C119.554 85.5387 119.881 84.5493 119.881 83.28V76.112H123.465V90H120.301L120.021 87.648C119.591 88.4693 118.966 89.1227 118.145 89.608C117.342 90.0933 116.399 90.336 115.317 90.336ZM126.836 90V69.84H130.42V90H126.836ZM138.982 90.336C137.246 90.336 135.902 89.7947 134.95 88.712C134.017 87.6293 133.55 86.0427 133.55 83.952V76.112H137.106V83.616C137.106 84.8107 137.349 85.7253 137.834 86.36C138.319 86.9947 139.085 87.312 140.13 87.312C141.119 87.312 141.931 86.9573 142.566 86.248C143.219 85.5387 143.546 84.5493 143.546 83.28V76.112H147.13V90H143.966L143.686 87.648C143.257 88.4693 142.631 89.1227 141.81 89.608C141.007 90.0933 140.065 90.336 138.982 90.336ZM150.501 90V76.112H153.665L153.973 77.988C154.421 77.316 155.009 76.784 155.737 76.392C156.484 75.9813 157.342 75.776 158.313 75.776C160.46 75.776 161.981 76.6067 162.877 78.268C163.381 77.5027 164.053 76.896 164.893 76.448C165.752 76 166.685 75.776 167.693 75.776C169.504 75.776 170.894 76.3173 171.865 77.4C172.836 78.4827 173.321 80.0693 173.321 82.16V90H169.737V82.496C169.737 81.3013 169.504 80.3867 169.037 79.752C168.589 79.1173 167.889 78.8 166.937 78.8C165.966 78.8 165.182 79.1547 164.585 79.864C164.006 80.5733 163.717 81.5627 163.717 82.832V90H160.133V82.496C160.133 81.3013 159.9 80.3867 159.433 79.752C158.966 79.1173 158.248 78.8 157.277 78.8C156.325 78.8 155.55 79.1547 154.953 79.864C154.374 80.5733 154.085 81.5627 154.085 82.832V90H150.501ZM189.136 90.308C187.698 90.308 186.448 90.0653 185.384 89.58C184.32 89.076 183.489 88.376 182.892 87.48C182.313 86.584 182.024 85.5387 182.024 84.344C182.024 83.0747 182.378 81.9267 183.088 80.9C183.797 79.8733 184.852 79.052 186.252 78.436C185.692 77.7827 185.29 77.1667 185.048 76.588C184.805 76.0093 184.684 75.3933 184.684 74.74C184.684 73.844 184.908 73.0507 185.356 72.36C185.804 71.6507 186.438 71.0907 187.26 70.68C188.1 70.2693 189.098 70.064 190.256 70.064C191.432 70.064 192.43 70.2787 193.252 70.708C194.073 71.1373 194.689 71.716 195.1 72.444C195.529 73.172 195.725 73.984 195.688 74.88H192.272C192.272 74.1893 192.066 73.676 191.656 73.34C191.264 72.9853 190.788 72.808 190.228 72.808C189.593 72.808 189.08 72.9853 188.688 73.34C188.314 73.6947 188.128 74.152 188.128 74.712C188.128 75.1787 188.277 75.6547 188.576 76.14C188.874 76.6253 189.313 77.1853 189.892 77.82L195.38 83.252C195.772 82.6173 196.182 81.88 196.612 81.04L197.228 79.808H200.896L199.916 81.712C199.169 83.224 198.422 84.5027 197.676 85.548L202.184 90H197.9L195.716 87.816C194.764 88.6933 193.746 89.328 192.664 89.72C191.6 90.112 190.424 90.308 189.136 90.308ZM185.496 84.12C185.496 85.0347 185.832 85.8093 186.504 86.444C187.194 87.06 188.109 87.368 189.248 87.368C190.872 87.368 192.281 86.7893 193.476 85.632L188.296 80.508C187.344 80.9187 186.634 81.432 186.168 82.048C185.72 82.664 185.496 83.3547 185.496 84.12ZM27.904 120V100.4H35.156C36.724 100.4 38.0213 100.661 39.048 101.184C40.0747 101.707 40.84 102.425 41.344 103.34C41.848 104.255 42.1 105.281 42.1 106.42C42.1 107.503 41.8573 108.501 41.372 109.416C40.8867 110.312 40.1307 111.04 39.104 111.6C38.0773 112.141 36.7613 112.412 35.156 112.412H31.488V120H27.904ZM31.488 109.5H34.932C36.1827 109.5 37.0787 109.229 37.62 108.688C38.18 108.128 38.46 107.372 38.46 106.42C38.46 105.449 38.18 104.693 37.62 104.152C37.0787 103.592 36.1827 103.312 34.932 103.312H31.488V109.5ZM50.5569 120.336C49.1569 120.336 47.9155 120.037 46.8329 119.44C45.7502 118.843 44.9009 118.003 44.2849 116.92C43.6689 115.837 43.3609 114.587 43.3609 113.168C43.3609 111.731 43.6595 110.452 44.2569 109.332C44.8729 108.212 45.7129 107.344 46.7769 106.728C47.8595 106.093 49.1289 105.776 50.5849 105.776C51.9475 105.776 53.1515 106.075 54.1969 106.672C55.2422 107.269 56.0542 108.091 56.6329 109.136C57.2302 110.163 57.5289 111.311 57.5289 112.58C57.5289 112.785 57.5195 113 57.5009 113.224C57.5009 113.448 57.4915 113.681 57.4729 113.924H46.9169C46.9915 115.007 47.3649 115.856 48.0369 116.472C48.7275 117.088 49.5582 117.396 50.5289 117.396C51.2569 117.396 51.8635 117.237 52.3489 116.92C52.8529 116.584 53.2262 116.155 53.4689 115.632H57.1089C56.8475 116.509 56.4089 117.312 55.7929 118.04C55.1955 118.749 54.4489 119.309 53.5529 119.72C52.6755 120.131 51.6769 120.336 50.5569 120.336ZM50.5849 108.688C49.7075 108.688 48.9329 108.94 48.2609 109.444C47.5889 109.929 47.1595 110.676 46.9729 111.684H53.8889C53.8329 110.769 53.4969 110.041 52.8809 109.5C52.2649 108.959 51.4995 108.688 50.5849 108.688ZM66.6192 120.336C65.3126 120.336 64.1459 120.019 63.1192 119.384C62.0926 118.749 61.2806 117.881 60.6832 116.78C60.0859 115.679 59.7872 114.428 59.7872 113.028C59.7872 111.628 60.0859 110.387 60.6832 109.304C61.2806 108.203 62.0926 107.344 63.1192 106.728C64.1459 106.093 65.3126 105.776 66.6192 105.776C67.6646 105.776 68.5792 105.972 69.3632 106.364C70.1472 106.756 70.7819 107.307 71.2672 108.016V99.84H74.8512V120H71.6592L71.2672 118.012C70.8192 118.628 70.2219 119.169 69.4752 119.636C68.7472 120.103 67.7952 120.336 66.6192 120.336ZM67.3752 117.2C68.5326 117.2 69.4752 116.817 70.2032 116.052C70.9499 115.268 71.3232 114.269 71.3232 113.056C71.3232 111.843 70.9499 110.853 70.2032 110.088C69.4752 109.304 68.5326 108.912 67.3752 108.912C66.2366 108.912 65.2939 109.295 64.5472 110.06C63.8006 110.825 63.4272 111.815 63.4272 113.028C63.4272 114.241 63.8006 115.24 64.5472 116.024C65.2939 116.808 66.2366 117.2 67.3752 117.2ZM82.9809 120.336C81.7862 120.336 80.8062 120.149 80.0409 119.776C79.2755 119.384 78.7062 118.871 78.3329 118.236C77.9595 117.601 77.7729 116.901 77.7729 116.136C77.7729 114.848 78.2769 113.803 79.2849 113C80.2929 112.197 81.8049 111.796 83.8209 111.796H87.3489V111.46C87.3489 110.508 87.0782 109.808 86.5369 109.36C85.9955 108.912 85.3235 108.688 84.5209 108.688C83.7929 108.688 83.1582 108.865 82.6169 109.22C82.0755 109.556 81.7395 110.06 81.6089 110.732H78.1089C78.2022 109.724 78.5382 108.847 79.1169 108.1C79.7142 107.353 80.4795 106.784 81.4129 106.392C82.3462 105.981 83.3915 105.776 84.5489 105.776C86.5275 105.776 88.0862 106.271 89.2249 107.26C90.3635 108.249 90.9329 109.649 90.9329 111.46V120H87.8809L87.5449 117.76C87.1342 118.507 86.5555 119.123 85.8089 119.608C85.0809 120.093 84.1382 120.336 82.9809 120.336ZM83.7929 117.536C84.8195 117.536 85.6129 117.2 86.1729 116.528C86.7515 115.856 87.1155 115.025 87.2649 114.036H84.2129C83.2609 114.036 82.5795 114.213 82.1689 114.568C81.7582 114.904 81.5529 115.324 81.5529 115.828C81.5529 116.369 81.7582 116.789 82.1689 117.088C82.5795 117.387 83.1209 117.536 83.7929 117.536ZM99.925 115.856C99.253 115.856 98.6277 115.781 98.049 115.632L97.013 116.668C97.3304 116.836 97.7597 116.976 98.301 117.088C98.8424 117.2 99.7197 117.312 100.933 117.424C102.781 117.592 104.125 118.031 104.965 118.74C105.805 119.449 106.225 120.429 106.225 121.68C106.225 122.501 106.001 123.276 105.553 124.004C105.105 124.751 104.414 125.348 103.481 125.796C102.548 126.263 101.353 126.496 99.897 126.496C97.9184 126.496 96.3224 126.123 95.109 125.376C93.8957 124.648 93.289 123.547 93.289 122.072C93.289 120.821 93.8957 119.739 95.109 118.824C94.7357 118.656 94.409 118.479 94.129 118.292C93.8677 118.105 93.6344 117.909 93.429 117.704V117.06L95.865 114.484C94.7824 113.532 94.241 112.309 94.241 110.816C94.241 109.883 94.465 109.033 94.913 108.268C95.3797 107.503 96.033 106.896 96.873 106.448C97.713 106 98.7304 105.776 99.925 105.776C100.709 105.776 101.437 105.888 102.109 106.112H107.373V108.296L104.993 108.464C105.366 109.173 105.553 109.957 105.553 110.816C105.553 111.749 105.329 112.599 104.881 113.364C104.433 114.129 103.78 114.736 102.921 115.184C102.081 115.632 101.082 115.856 99.925 115.856ZM99.925 113.112C100.653 113.112 101.25 112.916 101.717 112.524C102.202 112.132 102.445 111.572 102.445 110.844C102.445 110.116 102.202 109.556 101.717 109.164C101.25 108.772 100.653 108.576 99.925 108.576C99.1597 108.576 98.5437 108.772 98.077 109.164C97.6104 109.556 97.377 110.116 97.377 110.844C97.377 111.572 97.6104 112.132 98.077 112.524C98.5437 112.916 99.1597 113.112 99.925 113.112ZM96.565 121.708C96.565 122.399 96.8824 122.912 97.517 123.248C98.1704 123.603 98.9637 123.78 99.897 123.78C100.793 123.78 101.521 123.593 102.081 123.22C102.641 122.865 102.921 122.38 102.921 121.764C102.921 121.26 102.734 120.84 102.361 120.504C102.006 120.168 101.288 119.963 100.205 119.888C99.4397 119.832 98.7304 119.748 98.077 119.636C97.5357 119.935 97.1437 120.261 96.901 120.616C96.677 120.971 96.565 121.335 96.565 121.708ZM115.796 120.336C114.452 120.336 113.238 120.028 112.156 119.412C111.092 118.796 110.242 117.947 109.608 116.864C108.992 115.763 108.684 114.493 108.684 113.056C108.684 111.619 109.001 110.359 109.636 109.276C110.27 108.175 111.12 107.316 112.184 106.7C113.266 106.084 114.48 105.776 115.824 105.776C117.149 105.776 118.344 106.084 119.408 106.7C120.49 107.316 121.34 108.175 121.956 109.276C122.59 110.359 122.908 111.619 122.908 113.056C122.908 114.493 122.59 115.763 121.956 116.864C121.34 117.947 120.49 118.796 119.408 119.412C118.325 120.028 117.121 120.336 115.796 120.336ZM115.796 117.228C116.729 117.228 117.541 116.883 118.232 116.192C118.922 115.483 119.268 114.437 119.268 113.056C119.268 111.675 118.922 110.639 118.232 109.948C117.541 109.239 116.738 108.884 115.824 108.884C114.872 108.884 114.05 109.239 113.36 109.948C112.688 110.639 112.352 111.675 112.352 113.056C112.352 114.437 112.688 115.483 113.36 116.192C114.05 116.883 114.862 117.228 115.796 117.228ZM130.809 115.856C130.137 115.856 129.512 115.781 128.933 115.632L127.897 116.668C128.214 116.836 128.644 116.976 129.185 117.088C129.726 117.2 130.604 117.312 131.817 117.424C133.665 117.592 135.009 118.031 135.849 118.74C136.689 119.449 137.109 120.429 137.109 121.68C137.109 122.501 136.885 123.276 136.437 124.004C135.989 124.751 135.298 125.348 134.365 125.796C133.432 126.263 132.237 126.496 130.781 126.496C128.802 126.496 127.206 126.123 125.993 125.376C124.78 124.648 124.173 123.547 124.173 122.072C124.173 120.821 124.78 119.739 125.993 118.824C125.62 118.656 125.293 118.479 125.013 118.292C124.752 118.105 124.518 117.909 124.313 117.704V117.06L126.749 114.484C125.666 113.532 125.125 112.309 125.125 110.816C125.125 109.883 125.349 109.033 125.797 108.268C126.264 107.503 126.917 106.896 127.757 106.448C128.597 106 129.614 105.776 130.809 105.776C131.593 105.776 132.321 105.888 132.993 106.112H138.257V108.296L135.877 108.464C136.25 109.173 136.437 109.957 136.437 110.816C136.437 111.749 136.213 112.599 135.765 113.364C135.317 114.129 134.664 114.736 133.805 115.184C132.965 115.632 131.966 115.856 130.809 115.856ZM130.809 113.112C131.537 113.112 132.134 112.916 132.601 112.524C133.086 112.132 133.329 111.572 133.329 110.844C133.329 110.116 133.086 109.556 132.601 109.164C132.134 108.772 131.537 108.576 130.809 108.576C130.044 108.576 129.428 108.772 128.961 109.164C128.494 109.556 128.261 110.116 128.261 110.844C128.261 111.572 128.494 112.132 128.961 112.524C129.428 112.916 130.044 113.112 130.809 113.112ZM127.449 121.708C127.449 122.399 127.766 122.912 128.401 123.248C129.054 123.603 129.848 123.78 130.781 123.78C131.677 123.78 132.405 123.593 132.965 123.22C133.525 122.865 133.805 122.38 133.805 121.764C133.805 121.26 133.618 120.84 133.245 120.504C132.89 120.168 132.172 119.963 131.089 119.888C130.324 119.832 129.614 119.748 128.961 119.636C128.42 119.935 128.028 120.261 127.785 120.616C127.561 120.971 127.449 121.335 127.449 121.708ZM142.298 126.16L145.518 119.076H144.678L139.274 106.112H143.166L147.058 115.884L151.118 106.112H154.926L146.106 126.16H142.298Z",
    fill: "#FFB900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26.884 61V51.9H28.548V61H26.884ZM30.1297 61V54.552H31.5987L31.7287 55.644C31.9281 55.2627 32.2141 54.9593 32.5867 54.734C32.9681 54.5087 33.4144 54.396 33.9257 54.396C34.7231 54.396 35.3427 54.6473 35.7847 55.15C36.2267 55.6527 36.4477 56.3893 36.4477 57.36V61H34.7837V57.516C34.7837 56.9613 34.6711 56.5367 34.4457 56.242C34.2204 55.9473 33.8694 55.8 33.3927 55.8C32.9247 55.8 32.5391 55.9647 32.2357 56.294C31.9411 56.6233 31.7937 57.0827 31.7937 57.672V61H30.1297ZM40.7689 61C40.0929 61 39.5512 60.8353 39.1439 60.506C38.7366 60.1767 38.5329 59.5917 38.5329 58.751V55.943H37.4279V54.552H38.5329L38.7279 52.823H40.1969V54.552H41.9389V55.943H40.1969V58.764C40.1969 59.076 40.2619 59.2927 40.3919 59.414C40.5306 59.5267 40.7646 59.583 41.0939 59.583H41.8999V61H40.7689ZM46.1926 61.156C45.5426 61.156 44.9662 61.0173 44.4636 60.74C43.9609 60.4627 43.5666 60.0727 43.2806 59.57C42.9946 59.0673 42.8516 58.4867 42.8516 57.828C42.8516 57.1607 42.9902 56.567 43.2676 56.047C43.5536 55.527 43.9436 55.124 44.4376 54.838C44.9402 54.5433 45.5296 54.396 46.2056 54.396C46.8382 54.396 47.3972 54.5347 47.8826 54.812C48.3679 55.0893 48.7449 55.4707 49.0136 55.956C49.2909 56.4327 49.4296 56.9657 49.4296 57.555C49.4296 57.6503 49.4252 57.75 49.4166 57.854C49.4166 57.958 49.4122 58.0663 49.4036 58.179H44.5026C44.5372 58.6817 44.7106 59.076 45.0226 59.362C45.3432 59.648 45.7289 59.791 46.1796 59.791C46.5176 59.791 46.7992 59.7173 47.0246 59.57C47.2586 59.414 47.4319 59.2147 47.5446 58.972H49.2346C49.1132 59.3793 48.9096 59.752 48.6236 60.09C48.3462 60.4193 47.9996 60.6793 47.5836 60.87C47.1762 61.0607 46.7126 61.156 46.1926 61.156ZM46.2056 55.748C45.7982 55.748 45.4386 55.865 45.1266 56.099C44.8146 56.3243 44.6152 56.671 44.5286 57.139H47.7396C47.7136 56.7143 47.5576 56.3763 47.2716 56.125C46.9856 55.8737 46.6302 55.748 46.2056 55.748ZM50.6861 61V54.552H52.1681L52.3241 55.761C52.5581 55.345 52.8744 55.0157 53.2731 54.773C53.6804 54.5217 54.1571 54.396 54.7031 54.396V56.151H54.2351C53.8711 56.151 53.5461 56.2073 53.2601 56.32C52.9741 56.4327 52.7488 56.6277 52.5841 56.905C52.4281 57.1823 52.3501 57.568 52.3501 58.062V61H50.6861ZM55.6974 61V54.552H57.1664L57.2964 55.644C57.4957 55.2627 57.7817 54.9593 58.1544 54.734C58.5357 54.5087 58.982 54.396 59.4934 54.396C60.2907 54.396 60.9104 54.6473 61.3524 55.15C61.7944 55.6527 62.0154 56.3893 62.0154 57.36V61H60.3514V57.516C60.3514 56.9613 60.2387 56.5367 60.0134 56.242C59.788 55.9473 59.437 55.8 58.9604 55.8C58.4924 55.8 58.1067 55.9647 57.8034 56.294C57.5087 56.6233 57.3614 57.0827 57.3614 57.672V61H55.6974ZM65.6866 61.156C65.1319 61.156 64.6769 61.0693 64.3216 60.896C63.9662 60.714 63.7019 60.4757 63.5286 60.181C63.3552 59.8863 63.2686 59.5613 63.2686 59.206C63.2686 58.608 63.5026 58.1227 63.9706 57.75C64.4386 57.3773 65.1406 57.191 66.0766 57.191H67.7146V57.035C67.7146 56.593 67.5889 56.268 67.3376 56.06C67.0862 55.852 66.7742 55.748 66.4016 55.748C66.0636 55.748 65.7689 55.8303 65.5176 55.995C65.2662 56.151 65.1102 56.385 65.0496 56.697H63.4246C63.4679 56.229 63.6239 55.8217 63.8926 55.475C64.1699 55.1283 64.5252 54.864 64.9586 54.682C65.3919 54.4913 65.8772 54.396 66.4146 54.396C67.3332 54.396 68.0569 54.6257 68.5856 55.085C69.1142 55.5443 69.3786 56.1943 69.3786 57.035V61H67.9616L67.8056 59.96C67.6149 60.3067 67.3462 60.5927 66.9996 60.818C66.6616 61.0433 66.2239 61.156 65.6866 61.156ZM66.0636 59.856C66.5402 59.856 66.9086 59.7 67.1686 59.388C67.4372 59.076 67.6062 58.6903 67.6756 58.231H66.2586C65.8166 58.231 65.5002 58.3133 65.3096 58.478C65.1189 58.634 65.0236 58.829 65.0236 59.063C65.0236 59.3143 65.1189 59.5093 65.3096 59.648C65.5002 59.7867 65.7516 59.856 66.0636 59.856ZM73.6076 61C72.9316 61 72.39 60.8353 71.9826 60.506C71.5753 60.1767 71.3716 59.5917 71.3716 58.751V55.943H70.2666V54.552H71.3716L71.5666 52.823H73.0356V54.552H74.7776V55.943H73.0356V58.764C73.0356 59.076 73.1006 59.2927 73.2306 59.414C73.3693 59.5267 73.6033 59.583 73.9326 59.583H74.7386V61H73.6076ZM76.9603 53.551C76.657 53.551 76.4056 53.46 76.2063 53.278C76.0156 53.096 75.9203 52.8663 75.9203 52.589C75.9203 52.3117 76.0156 52.0863 76.2063 51.913C76.4056 51.731 76.657 51.64 76.9603 51.64C77.2636 51.64 77.5106 51.731 77.7013 51.913C77.9006 52.0863 78.0003 52.3117 78.0003 52.589C78.0003 52.8663 77.9006 53.096 77.7013 53.278C77.5106 53.46 77.2636 53.551 76.9603 53.551ZM76.1283 61V54.552H77.7923V61H76.1283ZM82.4801 61.156C81.8561 61.156 81.2928 61.013 80.7901 60.727C80.2961 60.441 79.9018 60.0467 79.6071 59.544C79.3211 59.0327 79.1781 58.4433 79.1781 57.776C79.1781 57.1087 79.3255 56.5237 79.6201 56.021C79.9148 55.5097 80.3091 55.111 80.8031 54.825C81.3058 54.539 81.8691 54.396 82.4931 54.396C83.1085 54.396 83.6631 54.539 84.1571 54.825C84.6598 55.111 85.0541 55.5097 85.3401 56.021C85.6348 56.5237 85.7821 57.1087 85.7821 57.776C85.7821 58.4433 85.6348 59.0327 85.3401 59.544C85.0541 60.0467 84.6598 60.441 84.1571 60.727C83.6545 61.013 83.0955 61.156 82.4801 61.156ZM82.4801 59.713C82.9135 59.713 83.2905 59.5527 83.6111 59.232C83.9318 58.9027 84.0921 58.4173 84.0921 57.776C84.0921 57.1347 83.9318 56.6537 83.6111 56.333C83.2905 56.0037 82.9178 55.839 82.4931 55.839C82.0511 55.839 81.6698 56.0037 81.3491 56.333C81.0371 56.6537 80.8811 57.1347 80.8811 57.776C80.8811 58.4173 81.0371 58.9027 81.3491 59.232C81.6698 59.5527 82.0468 59.713 82.4801 59.713ZM87.1269 61V54.552H88.5959L88.7259 55.644C88.9252 55.2627 89.2112 54.9593 89.5839 54.734C89.9652 54.5087 90.4116 54.396 90.9229 54.396C91.7202 54.396 92.3399 54.6473 92.7819 55.15C93.2239 55.6527 93.4449 56.3893 93.4449 57.36V61H91.7809V57.516C91.7809 56.9613 91.6682 56.5367 91.4429 56.242C91.2176 55.9473 90.8666 55.8 90.3899 55.8C89.9219 55.8 89.5362 55.9647 89.2329 56.294C88.9382 56.6233 88.7909 57.0827 88.7909 57.672V61H87.1269ZM97.1161 61.156C96.5614 61.156 96.1064 61.0693 95.7511 60.896C95.3958 60.714 95.1314 60.4757 94.9581 60.181C94.7848 59.8863 94.6981 59.5613 94.6981 59.206C94.6981 58.608 94.9321 58.1227 95.4001 57.75C95.8681 57.3773 96.5701 57.191 97.5061 57.191H99.1441V57.035C99.1441 56.593 99.0184 56.268 98.7671 56.06C98.5158 55.852 98.2038 55.748 97.8311 55.748C97.4931 55.748 97.1984 55.8303 96.9471 55.995C96.6958 56.151 96.5398 56.385 96.4791 56.697H94.8541C94.8974 56.229 95.0534 55.8217 95.3221 55.475C95.5994 55.1283 95.9548 54.864 96.3881 54.682C96.8214 54.4913 97.3068 54.396 97.8441 54.396C98.7628 54.396 99.4864 54.6257 100.015 55.085C100.544 55.5443 100.808 56.1943 100.808 57.035V61H99.3911L99.2351 59.96C99.0444 60.3067 98.7758 60.5927 98.4291 60.818C98.0911 61.0433 97.6534 61.156 97.1161 61.156ZM97.4931 59.856C97.9698 59.856 98.3381 59.7 98.5981 59.388C98.8668 59.076 99.0358 58.6903 99.1051 58.231H97.6881C97.2461 58.231 96.9298 58.3133 96.7391 58.478C96.5484 58.634 96.4531 58.829 96.4531 59.063C96.4531 59.3143 96.5484 59.5093 96.7391 59.648C96.9298 59.7867 97.1811 59.856 97.4931 59.856ZM102.253 61V51.64H103.917V61H102.253ZM105.474 61V51.64H107.138V61H105.474ZM109.502 63.86L110.997 60.571H110.607L108.098 54.552H109.905L111.712 59.089L113.597 54.552H115.365L111.27 63.86H109.502ZM119.303 61V51.9H122.956C123.901 51.9 124.62 52.121 125.114 52.563C125.617 52.9963 125.868 53.5553 125.868 54.24C125.868 54.812 125.712 55.2713 125.4 55.618C125.097 55.956 124.724 56.1857 124.282 56.307C124.802 56.411 125.231 56.671 125.569 57.087C125.907 57.4943 126.076 57.971 126.076 58.517C126.076 59.2363 125.816 59.83 125.296 60.298C124.776 60.766 124.039 61 123.086 61H119.303ZM120.967 55.722H122.709C123.177 55.722 123.537 55.6137 123.788 55.397C124.039 55.1803 124.165 54.8727 124.165 54.474C124.165 54.0927 124.039 53.7937 123.788 53.577C123.545 53.3517 123.177 53.239 122.683 53.239H120.967V55.722ZM120.967 59.648H122.826C123.32 59.648 123.701 59.5353 123.97 59.31C124.247 59.076 124.386 58.751 124.386 58.335C124.386 57.9103 124.243 57.5767 123.957 57.334C123.671 57.0913 123.285 56.97 122.8 56.97H120.967V59.648ZM130.455 61.156C129.805 61.156 129.229 61.0173 128.726 60.74C128.224 60.4627 127.829 60.0727 127.543 59.57C127.257 59.0673 127.114 58.4867 127.114 57.828C127.114 57.1607 127.253 56.567 127.53 56.047C127.816 55.527 128.206 55.124 128.7 54.838C129.203 54.5433 129.792 54.396 130.468 54.396C131.101 54.396 131.66 54.5347 132.145 54.812C132.631 55.0893 133.008 55.4707 133.276 55.956C133.554 56.4327 133.692 56.9657 133.692 57.555C133.692 57.6503 133.688 57.75 133.679 57.854C133.679 57.958 133.675 58.0663 133.666 58.179H128.765C128.8 58.6817 128.973 59.076 129.285 59.362C129.606 59.648 129.992 59.791 130.442 59.791C130.78 59.791 131.062 59.7173 131.287 59.57C131.521 59.414 131.695 59.2147 131.807 58.972H133.497C133.376 59.3793 133.172 59.752 132.886 60.09C132.609 60.4193 132.262 60.6793 131.846 60.87C131.439 61.0607 130.975 61.156 130.455 61.156ZM130.468 55.748C130.061 55.748 129.701 55.865 129.389 56.099C129.077 56.3243 128.878 56.671 128.791 57.139H132.002C131.976 56.7143 131.82 56.3763 131.534 56.125C131.248 55.8737 130.893 55.748 130.468 55.748ZM134.949 61V54.552H136.418L136.548 55.644C136.747 55.2627 137.033 54.9593 137.406 54.734C137.787 54.5087 138.233 54.396 138.745 54.396C139.542 54.396 140.162 54.6473 140.604 55.15C141.046 55.6527 141.267 56.3893 141.267 57.36V61H139.603V57.516C139.603 56.9613 139.49 56.5367 139.265 56.242C139.039 55.9473 138.688 55.8 138.212 55.8C137.744 55.8 137.358 55.9647 137.055 56.294C136.76 56.6233 136.613 57.0827 136.613 57.672V61H134.949ZM145.874 61.156C145.215 61.156 144.635 61.013 144.132 60.727C143.629 60.441 143.231 60.0423 142.936 59.531C142.65 59.0197 142.507 58.4347 142.507 57.776C142.507 57.1173 142.65 56.5323 142.936 56.021C143.231 55.5097 143.629 55.111 144.132 54.825C144.635 54.539 145.215 54.396 145.874 54.396C146.697 54.396 147.391 54.6127 147.954 55.046C148.517 55.4707 148.877 56.06 149.033 56.814H147.278C147.191 56.502 147.018 56.2593 146.758 56.086C146.507 55.904 146.208 55.813 145.861 55.813C145.402 55.813 145.012 55.9863 144.691 56.333C144.37 56.6797 144.21 57.1607 144.21 57.776C144.21 58.3913 144.37 58.8723 144.691 59.219C145.012 59.5657 145.402 59.739 145.861 59.739C146.208 59.739 146.507 59.6523 146.758 59.479C147.018 59.3057 147.191 59.0587 147.278 58.738H149.033C148.877 59.466 148.517 60.051 147.954 60.493C147.391 60.935 146.697 61.156 145.874 61.156ZM150.367 61V51.64H152.031V55.54C152.248 55.1847 152.538 54.9073 152.902 54.708C153.275 54.5 153.699 54.396 154.176 54.396C154.973 54.396 155.589 54.6473 156.022 55.15C156.464 55.6527 156.685 56.3893 156.685 57.36V61H155.034V57.516C155.034 56.9613 154.921 56.5367 154.696 56.242C154.479 55.9473 154.133 55.8 153.656 55.8C153.188 55.8 152.798 55.9647 152.486 56.294C152.183 56.6233 152.031 57.0827 152.031 57.672V61H150.367ZM158.133 61V54.552H159.602L159.745 55.423C159.953 55.111 160.226 54.864 160.564 54.682C160.911 54.4913 161.309 54.396 161.76 54.396C162.757 54.396 163.463 54.7817 163.879 55.553C164.113 55.1977 164.425 54.916 164.815 54.708C165.214 54.5 165.647 54.396 166.115 54.396C166.956 54.396 167.601 54.6473 168.052 55.15C168.503 55.6527 168.728 56.3893 168.728 57.36V61H167.064V57.516C167.064 56.9613 166.956 56.5367 166.739 56.242C166.531 55.9473 166.206 55.8 165.764 55.8C165.313 55.8 164.949 55.9647 164.672 56.294C164.403 56.6233 164.269 57.0827 164.269 57.672V61H162.605V57.516C162.605 56.9613 162.497 56.5367 162.28 56.242C162.063 55.9473 161.73 55.8 161.279 55.8C160.837 55.8 160.477 55.9647 160.2 56.294C159.931 56.6233 159.797 57.0827 159.797 57.672V61H158.133ZM172.388 61.156C171.833 61.156 171.378 61.0693 171.023 60.896C170.667 60.714 170.403 60.4757 170.23 60.181C170.056 59.8863 169.97 59.5613 169.97 59.206C169.97 58.608 170.204 58.1227 170.672 57.75C171.14 57.3773 171.842 57.191 172.778 57.191H174.416V57.035C174.416 56.593 174.29 56.268 174.039 56.06C173.787 55.852 173.475 55.748 173.103 55.748C172.765 55.748 172.47 55.8303 172.219 55.995C171.967 56.151 171.811 56.385 171.751 56.697H170.126C170.169 56.229 170.325 55.8217 170.594 55.475C170.871 55.1283 171.226 54.864 171.66 54.682C172.093 54.4913 172.578 54.396 173.116 54.396C174.034 54.396 174.758 54.6257 175.287 55.085C175.815 55.5443 176.08 56.1943 176.08 57.035V61H174.663L174.507 59.96C174.316 60.3067 174.047 60.5927 173.701 60.818C173.363 61.0433 172.925 61.156 172.388 61.156ZM172.765 59.856C173.241 59.856 173.61 59.7 173.87 59.388C174.138 59.076 174.307 58.6903 174.377 58.231H172.96C172.518 58.231 172.201 58.3133 172.011 58.478C171.82 58.634 171.725 58.829 171.725 59.063C171.725 59.3143 171.82 59.5093 172.011 59.648C172.201 59.7867 172.453 59.856 172.765 59.856ZM177.525 61V54.552H179.007L179.163 55.761C179.397 55.345 179.713 55.0157 180.112 54.773C180.519 54.5217 180.996 54.396 181.542 54.396V56.151H181.074C180.71 56.151 180.385 56.2073 180.099 56.32C179.813 56.4327 179.587 56.6277 179.423 56.905C179.267 57.1823 179.189 57.568 179.189 58.062V61H177.525ZM182.536 61V51.64H184.2V57.165L186.488 54.552H188.464L185.825 57.49L188.893 61H186.813L184.2 57.763V61H182.536ZM192.382 61.156C191.732 61.156 191.155 61.0173 190.653 60.74C190.15 60.4627 189.756 60.0727 189.47 59.57C189.184 59.0673 189.041 58.4867 189.041 57.828C189.041 57.1607 189.179 56.567 189.457 56.047C189.743 55.527 190.133 55.124 190.627 54.838C191.129 54.5433 191.719 54.396 192.395 54.396C193.027 54.396 193.586 54.5347 194.072 54.812C194.557 55.0893 194.934 55.4707 195.203 55.956C195.48 56.4327 195.619 56.9657 195.619 57.555C195.619 57.6503 195.614 57.75 195.606 57.854C195.606 57.958 195.601 58.0663 195.593 58.179H190.692C190.726 58.6817 190.9 59.076 191.212 59.362C191.532 59.648 191.918 59.791 192.369 59.791C192.707 59.791 192.988 59.7173 193.214 59.57C193.448 59.414 193.621 59.2147 193.734 58.972H195.424C195.302 59.3793 195.099 59.752 194.813 60.09C194.535 60.4193 194.189 60.6793 193.773 60.87C193.365 61.0607 192.902 61.156 192.382 61.156ZM192.395 55.748C191.987 55.748 191.628 55.865 191.316 56.099C191.004 56.3243 190.804 56.671 190.718 57.139H193.929C193.903 56.7143 193.747 56.3763 193.461 56.125C193.175 55.8737 192.819 55.748 192.395 55.748ZM199.839 61.156C199.232 61.156 198.691 61.0087 198.214 60.714C197.737 60.4193 197.36 60.0163 197.083 59.505C196.806 58.9937 196.667 58.413 196.667 57.763C196.667 57.113 196.806 56.5367 197.083 56.034C197.36 55.5227 197.737 55.124 198.214 54.838C198.691 54.5433 199.232 54.396 199.839 54.396C200.324 54.396 200.749 54.487 201.113 54.669C201.477 54.851 201.772 55.1067 201.997 55.436V51.64H203.661V61H202.179L201.997 60.077C201.789 60.363 201.512 60.6143 201.165 60.831C200.827 61.0477 200.385 61.156 199.839 61.156ZM200.19 59.7C200.727 59.7 201.165 59.5223 201.503 59.167C201.85 58.803 202.023 58.3393 202.023 57.776C202.023 57.2127 201.85 56.7533 201.503 56.398C201.165 56.034 200.727 55.852 200.19 55.852C199.661 55.852 199.224 56.0297 198.877 56.385C198.53 56.7403 198.357 57.1997 198.357 57.763C198.357 58.3263 198.53 58.79 198.877 59.154C199.224 59.518 199.661 59.7 200.19 59.7Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10322_9888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6114 37.5255C53.6114 39.5598 54.2229 39.6274 55.2919 39.6274V39.8476H50.8106V39.6274C51.6427 39.6274 51.9309 39.1869 51.9309 37.5768V29.7299C51.9309 28.5601 51.6929 28.1372 50.8445 28.1372V27.917H53.9172C57.2957 27.917 59.5363 28.3236 59.5363 31.34C59.5363 34.3565 57.2957 34.7468 53.9172 34.7468H53.6114V37.5267V37.5255ZM53.9172 34.5254C55.9886 34.5254 57.6855 34.4753 57.6855 31.34C57.6855 28.2048 55.9034 28.1372 53.9172 28.1372H53.6114V34.5266H53.9172V34.5254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.965 39.8468H60.1128V39.6266C60.7582 39.4402 60.792 39.1349 60.792 38.2704V33.5763C60.792 32.9832 60.6566 32.7456 59.9436 32.5592V32.3553L62.2695 31.8636V38.2704C62.2695 39.2188 62.3546 39.474 62.965 39.6266V39.8468ZM60.5038 29.594C60.5038 29.1023 60.8772 28.7295 61.3697 28.7295C61.8622 28.7295 62.2356 29.1023 62.2356 29.594C62.2356 30.0857 61.8447 30.4585 61.3697 30.4585C60.8947 30.4585 60.5038 30.0682 60.5038 29.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0792 39.8475H68.227V39.6436C68.8724 39.4572 68.9062 39.1356 68.9062 38.2711V34.6267C68.9062 33.4744 68.2947 32.7113 67.1744 32.7113C66.2922 32.7113 65.5791 33.5583 65.4426 34.1688V38.2874C65.4426 39.2195 65.5278 39.4735 66.1381 39.6261V39.8463H63.2859V39.6261C63.9313 39.4397 63.9476 39.1519 63.9476 38.2874V33.5595C63.9476 32.9664 63.8111 32.7462 63.0992 32.5598V32.3559L65.4414 31.8643V33.6434C65.7973 32.66 66.969 31.8643 68.0392 31.8643C69.4139 31.8643 70.3813 32.5249 70.3813 34.5754V38.2699C70.3813 39.202 70.4829 39.4898 71.0769 39.6424V39.8463L71.0792 39.8475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9904 39.8475H76.1382V39.6436C76.7836 39.4572 76.8174 39.1356 76.8174 38.2711V34.6267C76.8174 33.4744 76.2059 32.7113 75.0856 32.7113C74.2033 32.7113 73.4903 33.5583 73.3537 34.1688V38.2874C73.3537 39.2195 73.4389 39.4735 74.0493 39.6261V39.8463H71.1971V39.6261C71.8425 39.4397 71.8588 39.1519 71.8588 38.2874V33.5595C71.8588 32.9664 71.7234 32.7462 71.0104 32.5598V32.3559L73.3526 31.8643V33.6434C73.7085 32.66 74.8802 31.8643 75.9503 31.8643C77.3251 31.8643 78.2925 32.5249 78.2925 34.5754V38.2699C78.2925 39.202 78.394 39.4898 78.988 39.6424V39.8463L78.9904 39.8475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5958 38.7629L86.7988 38.8479C86.6973 39.3571 86.1196 40.0002 85.2374 40.0002C85.2374 40.0002 83.8965 40.034 83.7949 38.5765C83.5569 39.3897 82.5731 40.0002 81.3839 40.0002C81.3839 40.0002 79.449 40.0002 79.449 38.2549C79.449 36.5096 80.8914 36.1869 83.7949 35.4424V34.459C83.7949 32.7137 82.9127 31.7304 81.5543 32.3572C80.8926 32.6799 80.7911 33.0015 80.8926 33.0178C81.0968 33.0516 81.2835 33.1366 81.4189 33.3231C81.6733 33.6621 81.6056 34.1712 81.2485 34.4252C80.9089 34.6967 80.4165 34.628 80.162 34.2726C79.9753 34.0186 79.9415 33.6796 80.0769 33.4419C80.1959 33.1879 80.4841 32.6799 81.4014 32.1883C82.1308 31.8154 82.9629 31.8655 82.9629 31.8655C84.8126 31.8655 85.3226 33.238 85.3226 35.2548V38.1361C85.3226 38.1361 85.3062 39.2033 86.087 39.2033C86.087 39.2033 86.4767 39.2033 86.5958 38.7629ZM80.9603 37.8984C80.9603 38.3901 81.266 39.2371 82.3012 39.2371C83.2009 39.2371 83.6257 38.5928 83.7949 38.1862V35.6614C81.8262 36.1356 80.9603 36.8813 80.9603 37.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9129 37.762C93.7262 38.609 92.8603 39.9989 90.7725 39.9989C88.8714 39.9989 87.0719 38.44 87.0719 35.9491C87.0719 33.8647 88.5995 31.8643 91.1973 31.8643C92.8614 31.8643 93.3702 32.6274 93.5231 32.8977C93.6585 33.1354 93.6923 33.4569 93.5395 33.7284C93.3189 34.0838 92.8101 34.2376 92.453 34.0162C92.062 33.796 91.943 33.3043 92.1647 32.949C92.2838 32.7462 92.4705 32.6099 92.6397 32.5936C92.7926 32.5598 92.3339 32.0856 91.1973 32.0856C90.5181 32.0856 88.6509 32.5936 88.6509 35.7627C88.6509 38.0171 89.9241 38.9492 91.1296 39.0669C92.369 39.1682 93.4216 38.3725 93.7273 37.6769L93.9141 37.762H93.9129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2062 39.8471H94.354V39.6269C94.9994 39.4405 95.0332 39.1527 95.0332 38.2882V28.9838C95.0332 28.3908 94.8804 28.1531 94.1837 28.0179V27.7977L96.5258 27.3398V38.2882C96.5258 39.2203 96.611 39.4743 97.205 39.6269V39.8471H97.2062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.387 37.847C104.2 38.6439 103.266 39.9989 101.263 39.9989C99.1411 39.9989 97.6298 38.2362 97.6298 35.9992C97.6298 33.4907 99.2251 31.8643 101.33 31.8643C103.299 31.8643 104.658 33.1179 104.658 35.779H99.2251C99.2928 38.0672 100.312 38.9818 101.653 39.1181C102.671 39.2195 103.877 38.5927 104.181 37.762L104.384 37.847H104.387ZM103.199 35.5588C103.199 33.0841 102.096 32.0845 101.28 32.0845C100.313 32.0845 99.2263 33.4232 99.2263 35.5588H103.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 31.8782H107.238V33.7027H106.422V31.8782H104.66V31.0638H106.422V29.2393H107.238V31.0638H109V31.8782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 26.9092H36.3385V34.177H36.6863C39.0425 34.177 40.9727 34.1199 40.9727 30.5536C40.9727 26.9872 38.9456 26.9103 36.6863 26.9103V26.9092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0768 30.5524C43.0768 33.9638 40.5281 34.4263 36.6851 34.4263H36.3374V37.5872C36.3374 39.0634 36.621 39.6285 37.1414 39.844H48.9516L43.2134 29.9209L42.9835 29.5225C43.0442 29.8324 43.0768 30.1726 43.0768 30.5501V30.5524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.427 37.6466V28.722C34.427 27.5313 34.2087 27.0209 33.4712 26.9277L31.7382 29.9244L26 39.8451H33.8026C34.2554 39.5981 34.427 38.9701 34.427 37.6454V37.6466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 26.6585H41.3275L37.4764 20L33.6264 26.6585H36.6863Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10322_9888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint43_linear_10322_9888)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint44_linear_10322_9888)"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6979 166.9C51.3941 166.596 51.3941 166.106 51.6979 165.803L54.7124 162.777H42.8958C42.4674 162.777 42.1168 162.427 42.1168 162C42.1168 161.572 42.4674 161.222 42.8958 161.222H54.7124L51.6901 158.204C51.3863 157.901 51.3863 157.411 51.6901 157.107C51.9939 156.804 52.4846 156.804 52.7884 157.107L57.1505 161.455C57.4543 161.758 57.4543 162.248 57.1505 162.552L52.7962 166.9C52.4924 167.195 51.9939 167.195 51.6979 166.9Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_9888",
    x: 0,
    y: 0,
    width: 386,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_9888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_9888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10322_9888",
    x: 18,
    y: 140,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_9888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_9888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_9888",
    x1: 224.636,
    y1: 93.8699,
    x2: 224.636,
    y2: 166.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_9888",
    x1: 204.735,
    y1: 92.5151,
    x2: 204.735,
    y2: 165.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_9888",
    x1: 214.458,
    y1: 109.462,
    x2: 214.458,
    y2: 178.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_9888",
    x1: 232.627,
    y1: 114.102,
    x2: 232.627,
    y2: 177.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_9888",
    x1: 196.539,
    y1: 121.848,
    x2: 196.539,
    y2: 175.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10322_9888",
    x1: 214.577,
    y1: 164.3,
    x2: 214.577,
    y2: 191.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10322_9888",
    x1: 366.451,
    y1: 115.988,
    x2: 298.238,
    y2: 115.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10322_9888",
    x1: 329.267,
    y1: 182.204,
    x2: 329.267,
    y2: 159.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10322_9888",
    x1: 329.267,
    y1: 71.5837,
    x2: 329.267,
    y2: 154.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10322_9888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10322_9888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.622) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10322_9888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.622) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10322_9888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.622) rotate(-180) scale(50.7237 51.1706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10322_9888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10322_9888",
    x1: 363.056,
    y1: 185.132,
    x2: 295.478,
    y2: 185.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10322_9888",
    x1: 378.502,
    y1: 120.141,
    x2: 294.425,
    y2: 120.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10322_9888",
    x1: 231.438,
    y1: 148.027,
    x2: 231.579,
    y2: 195.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10322_9888",
    x1: 371.676,
    y1: 185.496,
    x2: 374.073,
    y2: 194.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10322_9888",
    x1: 373.655,
    y1: 185.228,
    x2: 373.683,
    y2: 194.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10322_9888",
    x1: 371.683,
    y1: 185.49,
    x2: 374.079,
    y2: 194.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10322_9888",
    x1: 360.413,
    y1: 86.8123,
    x2: 360.727,
    y2: 191.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10322_9888",
    x1: 320.586,
    y1: 183.638,
    x2: 315.739,
    y2: 200.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10322_9888",
    x1: 319.233,
    y1: 188.419,
    x2: 315.667,
    y2: 200.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10322_9888",
    x1: 331.951,
    y1: 86.8969,
    x2: 332.265,
    y2: 191.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10322_9888",
    x1: 346.891,
    y1: 77.7363,
    x2: 346.941,
    y2: 94.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10322_9888",
    x1: 346.915,
    y1: 86.8543,
    x2: 347.229,
    y2: 191.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10322_9888",
    x1: 346.927,
    y1: 90.965,
    x2: 346.961,
    y2: 102.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10322_9888",
    x1: 323.788,
    y1: 146.716,
    x2: 323.93,
    y2: 194.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10322_9888",
    x1: 318.447,
    y1: 146.732,
    x2: 318.589,
    y2: 194.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10322_9888",
    x1: 350.362,
    y1: 146.636,
    x2: 350.504,
    y2: 194.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10322_9888",
    x1: 285.278,
    y1: 149.511,
    x2: 285.331,
    y2: 167.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10322_9888",
    x1: 261.062,
    y1: 149.583,
    x2: 261.115,
    y2: 167.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10322_9888",
    x1: 285.247,
    y1: 138.95,
    x2: 285.279,
    y2: 149.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10322_9888",
    x1: 265.494,
    y1: 139.009,
    x2: 265.527,
    y2: 149.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10322_9888",
    x1: 285.328,
    y1: 166.509,
    x2: 285.413,
    y2: 195.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10322_9888",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10322_9888",
    x1: 331.615,
    y1: 137.594,
    x2: 331.615,
    y2: 194.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10322_9888",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10322_9888",
    x1: 331.615,
    y1: 135.995,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10322_9888",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10322_9888",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10322_9888",
    x1: 331.554,
    y1: 149.596,
    x2: 331.554,
    y2: 166.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10322_9888",
    x1: 331.624,
    y1: 179.486,
    x2: 331.624,
    y2: 190.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10322_9888",
    x1: 74,
    y1: 176,
    x2: 23.5788,
    y2: 170.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10322_9888",
    x1: 50,
    y1: 108.042,
    x2: 50,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_9888"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10322_9888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 20,
    fill: "white",
    transform: "translate(26 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp);
export default __webpack_public_path__ + "static/media/CP.9ec22db06e14ad2da5cde34e2aeb9f21.svg";
export { ForwardRef as ReactComponent };